"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18566,54392,75413,71682,91727],{

/***/ 81301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-card-head-title {\n      display: flex;\n      align-items: center;\n      font-size: 18px;\n      font-weight: 400;\n      color: ",
        ";\n    }\n\n    .ant-card-extra {\n      font-size: 18px;\n      text-align: right;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  flex-direction: column;\n  width: ",
        ";\n\n  .ant-card-head {\n    padding: ",
        ";\n    ",
        "\n  }\n\n  .ant-card-head-title {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-card-body {\n    padding: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    "profile-config": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || false,
        headerBackground: props.headerBackground,
        width: props.width || "100%",
        bodyPadding: props.bodyPadding || "20px",
        headPadding: props.headPadding || "0 20px",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-5f118f4a-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var headPadding = param.headPadding;
    return headPadding;
}, function(param) {
    var headerBackground = param.headerBackground;
    return headerBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), headerBackground);
}, function(param) {
    var bodyPadding = param.bodyPadding;
    return bodyPadding;
}, function(param) {
    var variant = param.variant;
    return variant && variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 8089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h_": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* unused harmony export MoreIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38504);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84607);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px !important;\n  border-right: none;\n  width: 256px;\n\n  li {\n    height: 30px;\n    line-height: 30px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  .ant-dropdown-menu-item .ant-dropdown-menu-item-only-child {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cd7a91fb-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var MenuItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-cd7a91fb-2"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(80));
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-3"
})(_templateObject3());
Dropdown.Menu = Menu;
Dropdown.Menu.Item = MenuItem;
Dropdown.MoreIcon = MoreIcon;
var DropdownMenu = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, Menu), {
    Item: MenuItem
});

/* harmony default export */ __webpack_exports__["ZP"] = (Dropdown);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: 0.2s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ';\n  transition: 0.2s;\n\n  ::before {\n    content: "";\n    display: block;\n    position: absolute;\n    width: 0px;\n    height: 1px;\n    background-color: ',
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  input {\n    position: inherit;\n    z-index: 1;\n    border: none;\n    background: transparent;\n  }\n\n  input::placeholder {\n    color: transparent;\n  }\n\n  input:focus {\n    outline: 0;\n  }\n\n  input:focus ~ ",
        ", input:not(:placeholder-shown) ~ ",
        " {\n    top: -20px;\n    font-size: 13px;\n  }\n\n  input:focus ~ ",
        "::before {\n    width: 100%;\n    transition: 0.5s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    height: "28px",
    color: _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray,
    size: "16px",
    as: "label"
}).withConfig({
    componentId: "sc-c91cfec7-0"
})(_templateObject());
var Bar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        activeColorBars: props.activeColorBar
    };
}).withConfig({
    componentId: "sc-c91cfec7-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var activeColorBar = param.activeColorBar;
    return activeColorBar || _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c91cfec7-2"
})(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, Label, Label, Bar, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props));
});
var InputContainer = function(_param) {
    var children = _param.children, className = _param.className, activeColorBar = _param.activeColorBar, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "activeColorBar"
    ]);
    var childrenProps = children.props;
    var placeholder = childrenProps.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bar, {
                activeColorBar: activeColorBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: placeholder || " "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputContainer);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 63757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px;\n\n  li {\n    height: 28px;\n    line-height: 28px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d17ef6e0-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d17ef6e0-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
Menu.MoreIcon = MoreIcon;
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 35266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56673);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next {\n      border: 1px solid ",
        ";\n      a {\n        padding: 0 10px;\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      margin-right: 0;\n      border: 1px solid ",
        ";\n    }\n\n    .ant-pagination-item {\n      margin-right: 0;\n      border-radius: 0;\n      border-color: ",
        ";\n\n      a {\n        color: ",
        ";\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .ant-pagination-item-active {\n      a {\n        color: ",
        ";\n        font-weight: 600;\n      }\n      background: ",
        ";\n    }\n\n    .ant-pagination-prev:focus .ant-pagination-item-link,\n    .ant-pagination-next:focus .ant-pagination-item-link,\n    .ant-pagination-prev:hover .ant-pagination-item-link,\n    .ant-pagination-next:hover .ant-pagination-item-link {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro)
};
var Pagination = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-31bb62cf-0"
})(_templateObject2(), function(props) {
    return type[props.type];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 50864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  outline: 0 !important;\n\n  .selected-flag {\n    height: 35px;\n    border: 1px solid ",
        ";\n    outline: 0;\n  }\n\n  > .react-tel-input.country-list {\n    list-style: none;\n    position: absolute !important;\n    z-index: 500 !important;\n    padding: 0;\n    margin: -1px 0 0 -1px;\n    background-color: ",
        ';\n    width: 310px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n    top: 34px;\n  }\n\n  input[type="tel"] {\n    outline: 0;\n    line-height: 35px;\n    height: 35px;\n    font-weight: 300;\n    width: 100%;\n    border: none;\n    font-size: 20px;\n    position: relative;\n    border-bottom: 1px solid ',
        ';\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  input[type="tel"]:focus,\n  input[type="text"]:focus {\n    border-color: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TelephoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-dcb2dc87-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);
/* harmony default export */ __webpack_exports__["Z"] = (TelephoneInput);


/***/ }),

/***/ 48308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "Mt": function() { return /* reexport */ DatePicker/* default */.Z; },
  "kC": function() { return /* reexport */ Flex/* default */.Z; },
  "u_": function() { return /* reexport */ Modal/* default */.Z; },
  "Ph": function() { return /* reexport */ Select/* default */.Z; },
  "xv": function() { return /* reexport */ Text/* default */.Z; },
  "u": function() { return /* reexport */ Tooltip/* default */.Z; }
});

// UNUSED EXPORTS: Autocomplete, Avatar, Card, Collapse, Dropdown, IconBase64, IconMoreOptions, IconWrapper, Iconmoon, Input, InputContainer, InputNumber, InputNumberContainer, Menu, Pagination, Popover, PopoverContent, PopoverContentWrapper, PopoverTitleWrapper, Radio, Steps, Table, Tabs, Tag, TelephoneInput, Textarea

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/DatePicker.js
var DatePicker = __webpack_require__(70420);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconBase64.js
var IconBase64 = __webpack_require__(37949);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputForm.js
var InputForm = __webpack_require__(23906);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Card.js
var Card = __webpack_require__(81301);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(93463);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/hoc/withSpacing.js
var withSpacing = __webpack_require__(97214);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Textarea.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n  resize: none;\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm/* default */.Z).withConfig({
    componentId: "sc-d3c3a5a9-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var common_Textarea = ((0,withSpacing/* default */.Z)(Textarea));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Dropdown.js
var Dropdown = __webpack_require__(8089);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/TelephoneInput.js
var TelephoneInput = __webpack_require__(50864);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Menu.js
var Menu = __webpack_require__(63757);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Checkbox.js
var Checkbox = __webpack_require__(81190);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 15 modules
var tabs = __webpack_require__(76750);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Tabs.js

function Tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .ant-tabs-nav {\n      margin: 0;\n    }\n\n    .ant-tabs-nav-list {\n      width: 100%;\n    }\n    .ant-tabs-tab {\n      margin-right: 0px !important;\n      width: 100%;\n      text-align: center;\n      display: block;\n      font-size: 16px;\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-tabs-nav .ant-tabs-nav-list {\n      border: 1px solid ",
        ";\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,\n    .ant-tabs-tab .ant-tabs-tab-active {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Tabs_templateObject()),
    "full-width": (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), color/* default.highempahis */.Z.highempahis, color/* default.whiteSmoke */.Z.whiteSmoke, color/* default.highempahis */.Z.highempahis)
};
var Tabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-ccea26c3-0"
})(_templateObject2(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ var common_Tabs = ((/* unused pure expression or super */ null && (Tabs)));

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Collapse.js

function Collapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  "
    ]);
    Collapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collapse_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Collapse_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var types = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Collapse_templateObject(), color/* default.light */.Z.light, color/* default.nightRider */.Z.nightRider)
};
var Collapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function(props) {
    return {
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-291816d3-0"
})(Collapse_templateObject1(), function(param) {
    var type = param.type;
    return types[type];
});
/* harmony default export */ var common_Collapse = ((/* unused pure expression or super */ null && (Collapse)));

// EXTERNAL MODULE: ./node_modules/antd/es/steps/index.js + 3 modules
var steps = __webpack_require__(91756);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Steps.js

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-steps-item-process .ant-steps-item-icon {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Steps = (0,styled_components_browser_esm/* default */.ZP)(steps/* default */.Z).withConfig({
    componentId: "sc-8b4bf621-0"
})(Steps_templateObject(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
/* harmony default export */ var common_Steps = ((/* unused pure expression or super */ null && (Steps)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Pagination.js
var Pagination = __webpack_require__(35266);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var Tooltip = __webpack_require__(39211);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Radio.js

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-wrapper:hover .ant-radio,\n  .ant-radio:hover .ant-radio-inner,\n  .ant-radio-input:focus + .ant-radio-inner,\n  .ant-radio-checked .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ",
        ";\n  }\n  .ant-radio-inner::after {\n    background-color: ",
        ";\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var Radio = ((0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-8f5670d5-0"
})(Radio_templateObject(), color/* default.veryLightGrey */.Z.veryLightGrey, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light));

;// CONCATENATED MODULE: ./src/@deprecated-ui/common/index.js


































/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 54392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ facebookIconBlue; },
/* harmony export */   "$s": function() { return /* binding */ minusIcon; },
/* harmony export */   "HM": function() { return /* binding */ googleIcon; },
/* harmony export */   "Ll": function() { return /* binding */ newChatIcon; },
/* harmony export */   "O4": function() { return /* binding */ removeIcon; },
/* harmony export */   "R7": function() { return /* binding */ plusIcon; },
/* harmony export */   "XT": function() { return /* binding */ newGoogleIcon; },
/* harmony export */   "_3": function() { return /* binding */ rightArrowIcon; },
/* harmony export */   "aq": function() { return /* binding */ stockbitIcon; },
/* harmony export */   "kn": function() { return /* binding */ adjustIcon; },
/* harmony export */   "pj": function() { return /* binding */ facebookIcon; },
/* harmony export */   "vq": function() { return /* binding */ successRegisterIcon; },
/* harmony export */   "wJ": function() { return /* binding */ pollingCloseIcon; }
/* harmony export */ });
/* unused harmony exports addPersonIcon, saveIcon, lockIcon, sortIcon, upIcon, downIcon, paperPlaneIcon */
var plusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC";
var minusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==";
var addPersonIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADhklEQVRo3uVa0W3iQBB9oPyHVICvgriDkAqgA7jvjBRSQbgOfNL8ByqIU0FMB9AB6QAq4H7eXkY+g9dk10TcShYysnf9PDNv3zzo7Pd7XMro4oLG1ak3ikgPQGq+Wqnq9pxgOk3STERGANxxXXHJB4ACwFxVi28JhiAyAP0Gc38AmLQJqluXSiKSA3g1QNYAngDcA7hR1Q6AG57/Igjw+ncRyc4eGdZEAeDWgJj6vGkRGQCYl17AIHZNdT2B/FbV1DdleF0KYMGvbgnuLGk2M0B+quq06cSqulXViQE0FJFZq2nGFHnn6YIP9KXBuhvy9IeqbtqKzMyw0TTQOhMAu9L8ccGISALgzi0aqmA5j2O1MWsyemRG/NypauiCzSrWaQVMHnohRmfJ00EbYBKnsyKldVFaJyqYfmQw/3cLICIpteHJYJJvhKcA8CoiaVMwrkDTSA/m5m1C+a7V6DUFs4rJNmbeVRs149jm1iesDXPfNnR5dDCqmpt+JLTscNJoraqtRAZGqg99WcQjKlMjk6I1a92KnXrGZgoA5l9NN97voryMIJNqqdmp3GsAxamAeF/BeXac9yxt8wTAixOeVNFZAyAzAM/m/kG5VqjS6/Y011s91bDg9qg7w0YtNyz0wZTJq9oDPtyIxd73ALJCtWUVx2rionNTwDAmxbakGspW1Bvtpu2BuecAxoGw7LxNQEZpatrfY2OBQEagiLgHvK+bz9ue5UQFu8TBAclT4Iw2bWOvmQ+ax9rFL7oFCB6ZUmo5sXhXcemSpLACULRtnl95iMOJZ9FbgEMAzyKyYzpmsfRYLRgyV4ZPV9PS8QrAhp9lak4YvZQ0fU3qHYvIkjS9aQ0MXfvHEoDs0EZZsz9NePQZtZWITGPps7/7DOsiN6kS7PcVSqPM7Pbeti831hGAtC6qls0yA2TBm4MUMCORGDU+9jXRCTr1Sc/Ofr8vi8ogZvmRN21N9PuQjNctdZXLmEBMexGlm+2SfvtmoaiDJOJA3IX0GrpGY61j0mZFDe1CO0GWANoWhxtfP6zJPrM1IZ9xt95GJICktCEHy4bOw8ND+cdYJ0FyWk8hAPTw+WcIK42CMqej5h6L8vGAeLQSBgA2VfXFYu7xSI28Kcuixp5C47a5QoKEHm8m6sFT+Zg7kxjZnx7o8Y+NtYlmKx1o55T/m5l0+oeh2qL3YGC+67iotvkPTTenKu8H9gUAAAAASUVORK5CYII=";
var saveIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qye2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qze2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PHBhdGggZD0iTTExLDJoLTFIOEg3SDRIMnYxMmgyaDhoMlY1LjZMMTEsMnogTTksM3YzSDhWM0g5eiBNNywzdjNINVYzSDd6IE01LDEzdi0zaDZ2M0g1eiBNMTMsMTNoLTFWOUg0djRIM1YzaDF2NGgzaDFoMlYzaDAuNUwxMyw1LjlWMTN6Ii8+PC9zdmc+";
var newChatIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACUklEQVRoQ+3ZwW3CMBQA0P+DyJkR2KBsUNigG5QjfB8KE7TdgErY4kY7QUeATlA6QbtB2xvi4upHGNFASIITxyCQOEASxe/72z92EM7kg2figJOBENEdAHQRsQUAc0R8HI/Hc9MRJwEhoikiduPZg4gdg/EeQkTcC9N9Q0Br/aaUavMx7yHcSCHEMwDc7sNIKSODl5DBYNBYrVYzAHhSSjEiCfMhpeQx4x/EIHhQa61/wzBsjkajnwTMUEo58g4SRwBAWym12E6prTR7kVJuJgBvUisNwcdNz/AEYFJuZ/olovf1HO2yRkZRTUMQUQsRZ1rrYRywAxFCaJcCAMiFAIAGAGwG905NMX8YiJnOXKCy9oRB1Ov1tkkvbyBFIv7NWi57pGhEJZAyEM4hZSGcQspEOIMci9hX+JJm001lL2uw2yD48T1rOSgVcixi/YAYFejKITYIbyC2CC8gRSAqhxSFqBRSJKIySNGISiBlICqBmJUlbxTE19hmZZdlPRGv2HkLtFVB7PV6zVqt9hk962zt+vFvG4TzHun3+zdBELzyjbXWizAMO7yCs0U4hxDRAyLem7RgTBAEQ60146I19qHl6aHltNPUIiLeFb9OaNDRCOc9IoT4Xkc+brFCOIWYgb6erXg3cM6pxd/JZPJluwvjLLW4fiyXy0YRjd6HdgaxjXja9RdI3gikRdT2eN72WFV228Z6U0cukAwRuKRW3ghkCKrVKXnbcxnsVuHOcLF1j2S4h9NTjtlp5Ae/K6etTL9Z4jvD+KXevJ5ONx0+42wgf0COBmCTeeVvAAAAAElFTkSuQmCC";
var stockbitIcon = "data:image/svg+xml;base64,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";
var adjustIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYklEQVQ4y82UQQoAIAgEs/fuc/yvnYQoAyvJFrx4kB1XJBEpkaolWNNAAKZlqw9AtMIcMjO9Rd7VuIoagdtj5yAr1uoCjpDHNPMO25vm1UArzRzknTTdDr1p/ve+vKLvP3YDR+4tcGuq0dsAAAAASUVORK5CYII=";
var lockIcon = "data:image/svg+xml;utf8;base64,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";
var rightArrowIcon = "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI2OC44MzIgMjY4LjgzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY4LjgzMiAyNjguODMyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTI2NS4xNzEsMTI1LjU3N2wtODAtODBjLTQuODgxLTQuODgxLTEyLjc5Ny00Ljg4MS0xNy42NzgsMGMtNC44ODIsNC44ODItNC44ODIsMTIuNzk2LDAsMTcuNjc4bDU4LjY2MSw1OC42NjFIMTIuNSAgIGMtNi45MDMsMC0xMi41LDUuNTk3LTEyLjUsMTIuNWMwLDYuOTAyLDUuNTk3LDEyLjUsMTIuNSwxMi41aDIxMy42NTRsLTU4LjY1OSw1OC42NjFjLTQuODgyLDQuODgyLTQuODgyLDEyLjc5NiwwLDE3LjY3OCAgIGMyLjQ0LDIuNDM5LDUuNjQsMy42NjEsOC44MzksMy42NjFzNi4zOTgtMS4yMjIsOC44MzktMy42NjFsNzkuOTk4LTgwQzI3MC4wNTMsMTM4LjM3MywyNzAuMDUzLDEzMC40NTksMjY1LjE3MSwxMjUuNTc3eiIgZmlsbD0iIzZiNmI2YiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
var sortIcon = "data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw==";
var upIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7";
var downIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7";
var googleIcon = "data:image/svg+xml;base64,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";
var newGoogleIcon = "data:image/svg+xml;base64,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";
var facebookIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA5LjMgMTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkuMyAxODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9DQo8L3N0eWxlPg0KPHBhdGggaWQ9ImYiIGNsYXNzPSJzdDAiIGQ9Ik02LjEsMThWOS44aDIuOGwwLjQtMy4ySDYuMXYtMkM2LjEsMy42LDYuMywzLDcuNywzbDEuNywwVjAuMUM5LjEsMC4xLDgsMCw2LjksMEM0LjQsMCwyLjgsMS41LDIuOCw0LjINCgl2Mi40SDB2My4yaDIuOFYxOEg2LjF6Ii8+DQo8L3N2Zz4NCg==";
var facebookIconBlue = "data:image/png;base64,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";
var paperPlaneIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";
var removeIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRjZFNkU7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik04LjQsMC44QzQuMywwLjgsMSw0LjEsMSw4LjFzMy4zLDcuNCw3LjQsNy40czcuNC0zLjMsNy40LTcuNFMxMi40LDAuOCw4LjQsMC44eiBNMTEuMSw4LjZINS42VjcuN2g1LjVWOC42eiINCgkvPg0KPC9zdmc+DQo=";
var pollingCloseIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMi4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNFOUU5RTk7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMCw5LjlDMTkuOSw0LjQsMTUuNC0wLjEsOS45LDBDNC40LDAuMS0wLjEsNC42LDAsMTAuMWMwLjEsNS41LDQuNiwxMCwxMC4xLDkuOUMxNS42LDE5LjksMjAuMSwxNS40LDIwLDkuOXoNCgkgTTEyLjgsMTMuNUwxMCwxMC43bC0yLjgsMi44bC0wLjctMC43TDkuMywxMEw2LjUsNy4ybDAuNy0wLjdMMTAsOS4zbDIuOC0yLjhsMC43LDAuN0wxMC43LDEwbDIuOCwyLjhMMTIuOCwxMy41eiIvPg0KPC9zdmc+DQo=";
var successRegisterIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";


/***/ }),

/***/ 96011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModals; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts + 4 modules
var usePortfolio = __webpack_require__(77596);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/PortoDetailModal.tsx + 18 modules
var PortoDetailModal = __webpack_require__(53887);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/OrderDetailModal.tsx + 2 modules
var OrderDetailModal = __webpack_require__(8587);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(11475);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/features/trade/components/styled.ts
var styled = __webpack_require__(94514);
;// CONCATENATED MODULE: ./src/features/chartbit/Modal/CancelModal.tsx














var CancelModal = function(param) {
    var data = param.data, visible = param.visible, _onCancel = param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel;
    var ref, ref1;
    var orderId = data.orderId, symbol = data.symbol;
    var orderHistory = tradingData/* default.getState */.Z.getState().orderHistory;
    var order = orderHistory === null || orderHistory === void 0 ? void 0 : (ref = orderHistory.data) === null || ref === void 0 ? void 0 : ref.find(function(o) {
        return o.orderid === orderId;
    });
    var isDayTrade = order.day_trade_is_day_trade;
    var isTrailingStop = (ref1 = order.trailing_stop) === null || ref1 === void 0 ? void 0 : ref1.id;
    var ref2 = (0,tradingOperation/* default */.Z)(), isLoading = ref2.postTradeCancelData.isLoading, _postDayTradeCancelData = ref2.postDayTradeCancelData, isDayTradeLoading = _postDayTradeCancelData.isLoading;
    var ref3 = (0,tradingOperation/* default */.Z)(function(s) {
        return {
            postTradeCancel: s.postTradeCancel,
            postDayTradeCancel: s.postDayTradeCancel,
            deleteTrailingStop: s.deleteTrailingStop
        };
    }, shallow/* default */.Z), postTradeCancel = ref3.postTradeCancel, postDayTradeCancel = ref3.postDayTradeCancel, deleteTrailingStop = ref3.deleteTrailingStop;
    var handleCancelOrderRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isTrailingStop) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return deleteTrailingStop(orderId);
                    case 3:
                        return _ctx.abrupt("return");
                    case 4:
                        if (!isDayTrade) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return postDayTradeCancel(orderId);
                    case 7:
                        return _ctx.abrupt("return");
                    case 8:
                        _ctx.next = 10;
                        return postTradeCancel({
                            orderkey: "W-WITHDRAW-".concat(Date.now()),
                            orderid: orderId,
                            symbol: symbol,
                            isRealTrading: true
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCancelOrderRequest() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelOrderClick = function(event) {
        event.stopPropagation();
        (0,maintenance/* withMaintenanceGuard */.L)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleCancelOrderRequest();
                    case 2:
                        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: visible,
        closable: true,
        width: "416px",
        centered: true,
        onCancel: onCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            padding: "20px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationCircleOutlined/* default */.Z, {
                            style: {
                                fontSize: "24px",
                                color: "#FCCC54"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "20px",
                            mt: "4px",
                            family: "bold",
                            color: "#000000A6",
                            children: "Do you want to cancel this order ?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mt: "40px",
                    width: "100%",
                    justify: "right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AlertCancelButton */.rq, {
                            onClick: onCancel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "primary",
                            onClick: handleCancelOrderClick,
                            loading: isLoading !== null && isLoading !== void 0 ? isLoading : isDayTradeLoading,
                            // @ts-expect-error
                            ml: "10px",
                            height: "35px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                color: color/* default.light */.Z.light,
                                children: "OK"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_CancelModal = (CancelModal);

;// CONCATENATED MODULE: ./src/features/chartbit/Modal/TradingModals.tsx
















var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(51225), __webpack_require__.e(48761), __webpack_require__.e(10231), __webpack_require__.e(70536), __webpack_require__.e(12104), __webpack_require__.e(37376), __webpack_require__.e(18027), __webpack_require__.e(74418)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(51225), __webpack_require__.e(33082), __webpack_require__.e(68106), __webpack_require__.e(20242), __webpack_require__.e(83474), __webpack_require__.e(83559)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var ChartbitTradingModals = function(param) {
    var portoData = param.portoData, cancelData = param.cancelData, orderData = param.orderData, onClose = param.onClose, setCancelData = param.setCancelData, setPortoData = param.setPortoData;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref = (0,tradingData/* default */.Z)(function(state) {
        return {
            getPortfolio: state.getPortfolio,
            getOrderHistory: state.getOrderHistory
        };
    }), getPortfolio = ref.getPortfolio, getOrderHistory = ref.getOrderHistory;
    (0,usePortfolio/* default */.Z)(true);
    var modal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openModal;
    });
    var setModal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setModal;
    });
    var modalData = (0,store/* default */.Z)(function(s) {
        return s.modalData;
    }, shallow/* default */.Z);
    (0,react.useEffect)(function() {
        if (isRealTrading || modal === types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION) {
            getPortfolio(isRealTrading, false);
            getOrderHistory(isRealTrading, false);
        }
    }, [
        isRealTrading,
        modal
    ]);
    (0,react.useEffect)(function() {
        if (modalData === null || modalData === void 0 ? void 0 : modalData.showShariaRestrictionBuy) {
            setModal(types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
        }
    }, [
        modalData
    ]);
    (0,react.useEffect)(function() {
        if (modal === types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED) {
            setPortoData(null);
        }
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: Boolean(cancelData),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_CancelModal, {
                    visible: Boolean(cancelData === null || cancelData === void 0 ? void 0 : cancelData.symbol),
                    data: cancelData,
                    onCancel: onClose
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: Boolean(portoData),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortoDetailModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    visible: Boolean(portoData === null || portoData === void 0 ? void 0 : portoData.symbol)
                }, portoData), {
                    onCancel: onClose
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: Boolean(orderData) && !(cancelData === null || cancelData === void 0 ? void 0 : cancelData.symbol),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailModal/* default */.Z, {
                    visible: Boolean(orderData === null || orderData === void 0 ? void 0 : orderData.symbol),
                    data: orderData,
                    onCancel: onClose,
                    onCancelOrder: function() {
                        if (orderData) {
                            setCancelData({
                                orderId: orderData.orderid,
                                symbol: orderData.symbol
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {})
        ]
    });
};
/* harmony default export */ var TradingModals = (ChartbitTradingModals);


/***/ }),

/***/ 68152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getPortoData; },
/* harmony export */   "H6": function() { return /* binding */ getCurrentLot; },
/* harmony export */   "Ji": function() { return /* binding */ clearPortoAndOrderLabel; },
/* harmony export */   "do": function() { return /* binding */ checkTradeableStatus; },
/* harmony export */   "x7": function() { return /* binding */ onOpenTrading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36902);
/* harmony import */ var features_securities_AuthModal_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24293);
/* harmony import */ var global_Securities_utils_maintenance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38525);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2078);
/* harmony import */ var global_Securities_stores_useOpeningAccountStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8948);
/* harmony import */ var features_securities_AuthModal_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41110);
/* harmony import */ var features_securities_AuthModal_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54855);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6430);
/* harmony import */ var _chartbit_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32713);












var clearPortoAndOrderLabel = function() {
    window.dispatchEvent(new CustomEvent("update-porto-list", {
        detail: []
    }));
    window.dispatchEvent(new CustomEvent("update-order-list", {
        detail: []
    }));
};
var checkTradeableStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tradeSymbol, orderId) {
        var ref, emittenInfo, type, emittenStatus, tradeable, isRight, isWarrant, isReksadana, isSuspended, status, isTradeable, isAmendable, ref1, orderHistory, order, ref2, right, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!tradeSymbol) {
                        _ctx.next = 33;
                        break;
                    }
                    ;
                    emittenInfo = (ref = _chartbit_store__WEBPACK_IMPORTED_MODULE_10__/* .useChartbitStore.getState */ .E.getState().companyDetail[tradeSymbol]) === null || ref === void 0 ? void 0 : ref.data;
                    type = (emittenInfo === null || emittenInfo === void 0 ? void 0 : emittenInfo.type_company) || "";
                    emittenStatus = (emittenInfo === null || emittenInfo === void 0 ? void 0 : emittenInfo.status) || "";
                    tradeable = (emittenInfo === null || emittenInfo === void 0 ? void 0 : emittenInfo.tradeable) || false;
                    isRight = type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.right */ .L2.right;
                    isWarrant = type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.waran */ .L2.waran;
                    isReksadana = type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.reksadana */ .L2.reksadana;
                    isSuspended = emittenStatus === "STATUS_SUSPENDED";
                    status = global_Securities_stores_useOpeningAccountStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getState */ .Z.getState().status;
                    if (!(isSuspended || status !== features_securities_AuthModal_types__WEBPACK_IMPORTED_MODULE_7__/* .AuthModalStatus.COMPLETED */ .X.COMPLETED)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        isTradeable: false,
                        isAmendable: false,
                        type_company: type
                    });
                case 13:
                    isTradeable = Boolean(tradeable);
                    isAmendable = false;
                    if (orderId) {
                        ;
                        orderHistory = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().orderHistory;
                        order = orderHistory === null || orderHistory === void 0 ? void 0 : (ref1 = orderHistory.data) === null || ref1 === void 0 ? void 0 : ref1.find(function(o) {
                            return o.orderid === orderId;
                        });
                        isAmendable = Boolean(order === null || order === void 0 ? void 0 : order.amend_action);
                    }
                    if (!isRight) {
                        _ctx.next = 24;
                        break;
                    }
                    _ctx.next = 19;
                    return lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().checkRightTradeable();
                case 19:
                    ref2 = _ctx.sent;
                    right = ref2.data;
                    isTradeable = right === null || right === void 0 ? void 0 : right.is_tradeable;
                    _ctx.next = 32;
                    break;
                case 24:
                    if (!isWarrant) {
                        _ctx.next = 31;
                        break;
                    }
                    _ctx.next = 27;
                    return lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getExercise(tradeSymbol);
                case 27:
                    data = _ctx.sent.data;
                    isTradeable = data === null || data === void 0 ? void 0 : data.is_tradeable;
                    _ctx.next = 32;
                    break;
                case 31:
                    if (isReksadana) {
                        isTradeable = false;
                    }
                case 32:
                    return _ctx.abrupt("return", {
                        isTradeable: isTradeable,
                        isAmendable: isAmendable,
                        type_company: type
                    });
                case 33:
                    return _ctx.abrupt("return", {
                        isTradeable: false,
                        isAmendable: false,
                        type_company: ""
                    });
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkTradeableStatus(tradeSymbol, orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getCurrentLot = function(tradeSymbol) {
    var result = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().portfolio.data.result;
    var dayTradeResult = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().portfolio.data.day_trade;
    var hasPorto = result === null || result === void 0 ? void 0 : result.find(function(port) {
        return port.symbol === tradeSymbol;
    });
    var hasDT = dayTradeResult === null || dayTradeResult === void 0 ? void 0 : dayTradeResult.find(function(port) {
        return port.symbol === tradeSymbol;
    });
    var regularLot = (hasPorto === null || hasPorto === void 0 ? void 0 : hasPorto.balance_lot) || 0;
    var dayTradeLot = (hasDT === null || hasDT === void 0 ? void 0 : hasDT.balance_lot) || 0;
    var lot = regularLot + dayTradeLot;
    return lot;
};
var getPortoData = function(sym, isDayTrade) {
    var result = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().portfolio.data.result;
    var dayTradeResult = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().portfolio.data.day_trade;
    var newPortoData = isDayTrade ? dayTradeResult.find(function(res) {
        return res.symbol === sym;
    }) : result.find(function(res) {
        return res.symbol === sym;
    });
    return newPortoData;
};
var onOpenTrading = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, setPortoData, syariahData) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,global_Securities_utils_maintenance__WEBPACK_IMPORTED_MODULE_4__/* .withMaintenanceGuard */ .L)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        var isUserSyariah, checkSyariahTradeableStatus, showSyariahRestrictionModal, ref, emittenInfo, indexes, isSyariah, isTradeable, isAutoOrder, isDayTrade, sym, newPortoData, ref1, ref2, orderHistory, order;
                        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    isUserSyariah = syariahData.isUserSyariah, checkSyariahTradeableStatus = syariahData.checkSyariahTradeableStatus, showSyariahRestrictionModal = syariahData.showSyariahRestrictionModal;
                                    if (!isUserSyariah) {
                                        _ctx.next = 17;
                                        break;
                                    }
                                    _ctx.next = 4;
                                    return lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getCompany(data.symbol);
                                case 4:
                                    ref = _ctx.sent;
                                    emittenInfo = ref.data;
                                    indexes = emittenInfo.indexes;
                                    isSyariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
                                    if (isSyariah) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    showSyariahRestrictionModal();
                                    return _ctx.abrupt("return");
                                case 11:
                                    _ctx.next = 13;
                                    return checkSyariahTradeableStatus(data.symbol);
                                case 13:
                                    isTradeable = _ctx.sent;
                                    if (isTradeable) {
                                        _ctx.next = 17;
                                        break;
                                    }
                                    showSyariahRestrictionModal();
                                    return _ctx.abrupt("return");
                                case 17:
                                    isAutoOrder = [
                                        global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_5__/* .SellOrderType.StopLoss */ .qK.StopLoss,
                                        global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_5__/* .SellOrderType.TakeProfit */ .qK.TakeProfit, 
                                    ].includes(data.formType);
                                    if (isAutoOrder) {
                                        isDayTrade = data.isDayTrade, sym = data.symbol;
                                        newPortoData = getPortoData(sym, isDayTrade);
                                        if (newPortoData) {
                                            ;
                                            setPortoData({
                                                symbol: sym,
                                                isDayTrade: isDayTrade,
                                                exerciseable: newPortoData === null || newPortoData === void 0 ? void 0 : (ref1 = newPortoData.exercise_data) === null || ref1 === void 0 ? void 0 : ref1.active,
                                                type: newPortoData === null || newPortoData === void 0 ? void 0 : newPortoData.type,
                                                initialModalType: "auto-order",
                                                initialAutoOrderType: data.formType
                                            });
                                        }
                                    } else if (data.orderId) {
                                        ;
                                        orderHistory = lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().orderHistory;
                                        order = orderHistory === null || orderHistory === void 0 ? void 0 : (ref2 = orderHistory.data) === null || ref2 === void 0 ? void 0 : ref2.find(function(o) {
                                            return o.orderid === data.orderId;
                                        });
                                        if (order === null || order === void 0 ? void 0 : order.amend_action) {
                                            (0,features_securities_AuthModal_utils__WEBPACK_IMPORTED_MODULE_3__/* .showTradingModalWithAuth */ .Y)({
                                                symbol: data.symbol,
                                                price: Math.floor(data.newPrice),
                                                orderType: order.action === "BUY" ? features_securities_AuthModal_constants__WEBPACK_IMPORTED_MODULE_8__/* .AUTH_ORDER_TYPE.AMEND_BUY */ .q.AMEND_BUY : features_securities_AuthModal_constants__WEBPACK_IMPORTED_MODULE_8__/* .AUTH_ORDER_TYPE.AMEND_SELL */ .q.AMEND_SELL,
                                                orderedLot: order.order_total,
                                                orderid: data.orderId,
                                                orderedPrice: order.price_order,
                                                isDayTrade: order.day_trade_is_day_trade,
                                                formType: data.formType,
                                                setToMaxLot: data.setToMaxLot
                                            }, clearPortoAndOrderLabel);
                                        } else {
                                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                                content: "Unable to amend this order",
                                                alertType: "snackbar-dark",
                                                messageType: "error",
                                                hasCloseIcon: true
                                            });
                                        }
                                    } else {
                                        (0,features_securities_AuthModal_utils__WEBPACK_IMPORTED_MODULE_3__/* .showTradingModalWithAuth */ .Y)({
                                            symbol: data.symbol,
                                            price: Math.floor(data.newPrice),
                                            orderType: data.orderType,
                                            formType: data.formType,
                                            setToMaxLot: data.setToMaxLot
                                        }, clearPortoAndOrderLabel);
                                    }
                                case 19:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function onOpenTrading(data, setPortoData, syariahData) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 54855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AUTH_MODAL_CONFIG; },
/* harmony export */   "q": function() { return /* binding */ AUTH_ORDER_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var AUTH_ORDER_TYPE = {
    BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
    SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
    AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
    AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
};
var AUTH_MODAL_CONFIG = {
    real: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    },
    virtual: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_SELL */ .Jm.VIRTUAL_SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL
    }
};


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 41110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AuthModalType; },
/* harmony export */   "X": function() { return /* binding */ AuthModalStatus; }
/* harmony export */ });
var AuthModalType;
(function(AuthModalType) {
    AuthModalType["LOGIN"] = "login";
    AuthModalType["REGISTER"] = "register";
    AuthModalType["PROGRESS"] = "progress";
})(AuthModalType || (AuthModalType = {}));
var AuthModalStatus;
(function(AuthModalStatus) {
    AuthModalStatus[AuthModalStatus["UNREGISTERED"] = 0] = "UNREGISTERED";
    AuthModalStatus[AuthModalStatus["INCOMPLETE"] = 1] = "INCOMPLETE";
    AuthModalStatus[AuthModalStatus["CS"] = 2] = "CS";
    AuthModalStatus[AuthModalStatus["KSEI"] = 3] = "KSEI";
    AuthModalStatus[AuthModalStatus["RDN"] = 4] = "RDN";
    AuthModalStatus[AuthModalStatus["REJECTED"] = 99] = "REJECTED";
    AuthModalStatus[AuthModalStatus["COMPLETED"] = 100] = "COMPLETED";
})(AuthModalStatus || (AuthModalStatus = {}));


/***/ }),

/***/ 24293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ showTradingModalWithAuth; }
/* harmony export */ });
/* unused harmony export getAuthModalError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var global_MainLayout_ModalErrorMessage_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5728);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34385);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70175);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54855);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4621);











var showTradingModalWithAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tradingModalConfig, needLoginCallback) {
        var tradingType, showAuthModal, showTradingModal, getTradingBalance, res;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tradingType = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTradingAccountType */ .Z.getTradingAccountType();
                    showAuthModal = _store__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getState */ .Z.getState().showModal;
                    showTradingModal = global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().showModal;
                    getTradingBalance = lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().getTradingBalance;
                    if (tradingType) {
                        _ctx.next = 8;
                        break;
                    }
                    showAuthModal(tradingModalConfig);
                    if (needLoginCallback) {
                        needLoginCallback();
                    }
                    return _ctx.abrupt("return");
                case 8:
                    _ctx.next = 10;
                    return getTradingBalance();
                case 10:
                    res = _ctx.sent;
                    if (res === null || res === void 0 ? void 0 : res.aggregated_portfolio_summary) {
                        showTradingModal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, tradingModalConfig), {
                            orderType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .AUTH_MODAL_CONFIG */ .n[tradingType][tradingModalConfig.orderType]
                        }));
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function showTradingModalWithAuth(tradingModalConfig, needLoginCallback) {
        return _ref.apply(this, arguments);
    };
}();
var getAuthModalError = function(errorCode, errorType) {
    var ref;
    if (isNewCoreUser() && errorType) {
        return errorType !== "INVALID_CREDS";
    }
    var errorTradingModalConfig = tradingErrorModalList === null || tradingErrorModalList === void 0 ? void 0 : (ref = tradingErrorModalList[errorCode]) === null || ref === void 0 ? void 0 : ref[errorType];
    return !!errorTradingModalConfig;
};


/***/ }),

/***/ 94514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ TradingContainer; },
/* harmony export */   "Lb": function() { return /* binding */ FilterButton; },
/* harmony export */   "Lw": function() { return /* binding */ CancelButton; },
/* harmony export */   "NF": function() { return /* binding */ DiscoverButton; },
/* harmony export */   "_u": function() { return /* binding */ HeaderBox; },
/* harmony export */   "c7": function() { return /* binding */ ModalButtonContainerSecondary; },
/* harmony export */   "eL": function() { return /* binding */ PortfolioTable; },
/* harmony export */   "gM": function() { return /* binding */ HeaderContainer; },
/* harmony export */   "nO": function() { return /* binding */ DescInput; },
/* harmony export */   "pl": function() { return /* binding */ ModalTradingButton; },
/* harmony export */   "qD": function() { return /* binding */ ModalButtonContainer; },
/* harmony export */   "rq": function() { return /* binding */ AlertCancelButton; },
/* harmony export */   "wn": function() { return /* binding */ Filter; }
/* harmony export */ });
/* unused harmony exports CellLabel, SpinnerBox */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77148);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20px;\n\n  :last-child {\n    border: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  grid-template-columns: repeat(2, 2fr);\n  grid-template-rows: 2fr;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  background: white;\n  margin-bottom: 20px;\n  width: 100%;\n  border-radius: 4px;\n\n  ",
        " {\n    display: inline-block;\n    width: calc(100% / 3);\n    border-right: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    :nth-child(3),\n    :nth-child(5) {\n      border-right: unset;\n    }\n    :nth-child(4),\n    :nth-child(5) {\n      border-bottom: unset;\n      width: 50%;\n    }\n  }\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-template-rows: 1fr;\n    ",
        " {\n      display: block;\n      width: 100% !important;\n      border-right: 1px solid ",
        "!important;\n      border-bottom: none;\n\n      :last-child {\n        border-right: unset !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1250px;\n  cursor: pointer;\n  .ant-table-thead > tr > th {\n    height: 17px;\n    font-size: 14px;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-table-tbody > tr:last-child > td {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-pagination {\n    display: none;\n  }\n\n  .ant-table-thead > tr > th {\n    font-size: 14px;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    &:nth-child(1) {\n      border-left: 1px solid ",
        ";\n    }\n\n    &:nth-child(10) {\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td:not(.td-mobile) {\n    display: none;\n  }\n\n  .ant-table-content {\n    overflow-x: unset;\n  }\n\n  .ant-table-tbody > tr > td {\n    &:nth-child(1) {\n      border-left: 1px solid ",
        ";\n      font-family: var(--font-bold);\n    }\n\n    &:nth-child(10) {\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-table-tbody > tr > .td-mobile:first-child {\n    display: block;\n    width: 100vw;\n    border-width: 0;\n    height: 25px;\n  }\n\n  /* Invested column */\n  .ant-table-tbody > tr > td:nth-child(6) {\n    text-align: left !important;\n  }\n  /* Action column */\n  .ant-table-tbody > tr > td:last-child > div {\n    height: 37px;\n  }\n\n  .ant-table-tbody > tr > .td-mobile {\n    display: inline-block;\n    width: calc(100vw / 4);\n  }\n\n  ",
        " {\n    display: block;\n  }\n\n  .ant-table-empty .ant-table-tbody > tr > td {\n    border-right: 1px solid ",
        ";\n  }\n\n  .ant-table-row.empty-row {\n    cursor: default;\n    background-color: #f7f7f7;\n\n    > .ant-table-cell {\n      background-color: #f7f7f7;\n      border-right: none;\n      &:nth-child(1) {\n        border-left: 1px solid ",
        ";\n        font-family: var(--font-bold);\n      }\n\n      &:nth-child(10) {\n        border-right: 1px solid ",
        ";\n      }\n    }\n  }\n\n  @media ",
        " {\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td:not(.td-mobile) {\n      display: table-cell;\n    }\n\n    .ant-table-content {\n      overflow-x: auto;\n    }\n\n    .ant-table-tbody > tr > .td-mobile:first-child,\n    .ant-table-tbody > tr > .td-mobile {\n      display: table-cell;\n      width: inherit;\n      border-width: 1px;\n    }\n\n    /* Invested column */\n    .ant-table-tbody > tr > td:nth-child(6) {\n      text-align: right !important;\n    }\n    /* Action column */\n    .ant-table-tbody > tr > td:last-child > div {\n      height: unset;\n    }\n\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 200px;\n  width: 100%;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 20px;\n  width: 20px;\n  padding: unset;\n\n  &[disabled] {\n    background: #dadada;\n    border: 1px solid #dadada;\n    color: #ffffff;\n\n    &:hover {\n      background: #dadada;\n      border: 1px solid #dadada;\n      color: #ffffff;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #f7f7f7;\n  height: 35px;\n  width: 75px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ::placeholder {\n    color: ",
        ";\n    font-family: var(--font-bold);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 14px;\n  flex-direction: column;\n\n  > div:first-child {\n    margin-bottom: 10px;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n\n    > div {\n      margin-bottom: 0 !important;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 16px;\n  background: none;\n  border: none;\n  color: ",
        ";\n  border: 1px solid transparent;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17px;\n  cursor: pointer;\n\n  &.active {\n    border: 1px solid ",
        ";\n    border-radius: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: 1px solid ",
        ";\n  max-width: 1250px;\n  background: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -60px;\n  left: 0px;\n  width: 100%;\n  gap: 12px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 20px;\n  border-top: 1px solid #f1f1f1;\n  gap: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  font-size: 16px;\n  color: ",
        " !important;\n  font-family: var(--font-bold);\n  background: ",
        ";\n  border-color: ",
        ";\n\n  &.sell {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &.exercise {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &.support {\n    background: ",
        ";\n    border-color: ",
        ";\n    font-size: 14px;\n  }\n\n  .icon-widget_support {\n    color: ",
        ";\n    margin-right: 5px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  &:disabled,\n  &:hover:disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #cbcbcb;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n  padding: 6px 20px;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n\n  &:hover {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}








var HeaderBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-6a1fbf3-0"
})(_templateObject());
var HeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a1fbf3-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, HeaderBox, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tablet */ .Z.tablet, HeaderBox, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var CellLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].midgray */ .Z.midgray,
    size: "12px",
    align: "inherit"
}).withConfig({
    componentId: "sc-6a1fbf3-2"
})(_templateObject2());
var PortfolioTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Table__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, CellLabel, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mobileL */ .Z.mobileL, CellLabel);
var SpinnerBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-6a1fbf3-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    ml: "10px"
}).withConfig({
    componentId: "sc-6a1fbf3-5"
})(_templateObject5());
var AlertCancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-6"
})(_templateObject6());
var DescInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).withConfig({
    componentId: "sc-6a1fbf3-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var Filter = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-8"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mobileL */ .Z.mobileL);
var FilterButton = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6a1fbf3-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
var TradingContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a1fbf3-10"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var ModalButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-11"
})(_templateObject11());
var ModalButtonContainerSecondary = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-12"
})(_templateObject12());
var ModalTradingButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dimGray */ .Z.dimGray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dimGray */ .Z.dimGray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var DiscoverButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-14"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);


/***/ }),

/***/ 21455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export TradingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TradingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    tradingStore: null
});
/* harmony default export */ __webpack_exports__["Z"] = (TradingContext);


/***/ }),

/***/ 207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/transaction/store.ts



var initialState = {
    openModal: "",
    symbol: null,
    orderType: null,
    formType: null,
    openFromWidget: false
};
var tradingStore = function() {
    return (0,esm/* default */.ZP)(function(set) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
            setModal: function(modal, payload) {
                set((0,_object_spread/* default */.Z)({
                    openModal: modal
                }, payload));
            },
            resetModal: function() {
                set(initialState);
            },
            setSymbol: function(symbol) {
                set({
                    symbol: symbol
                });
            },
            setOrderType: function(type) {
                set({
                    orderType: type
                });
            },
            setFormType: function(type) {
                set({
                    formType: type
                });
            },
            setOpenFromWidget: function(open) {
                set({
                    openFromWidget: open
                });
            },
            setAutoOrderId: function(autoOrderId) {
                set({
                    autoOrderId: autoOrderId
                });
            }
        });
    });
};
/* harmony default export */ var store = (tradingStore);

// EXTERNAL MODULE: ./src/features/transaction/context.tsx
var context = __webpack_require__(21455);
;// CONCATENATED MODULE: ./src/features/transaction/provider.tsx




var TradingContextProvider = function(param) {
    var children = param.children;
    var formValuesContext = (0,react.useMemo)(function() {
        return {
            tradingStore: store()
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: formValuesContext,
        children: children
    });
};
/* harmony default export */ var provider = (TradingContextProvider);


/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 27934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LivePriceSymbolsKeyEnum; }
/* harmony export */ });
var LivePriceSymbolsKeyEnum;
(function(LivePriceSymbolsKeyEnum) {
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_WATCHLIST"] = "sideWidgetWatchlist";
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    LivePriceSymbolsKeyEnum["COMPANY_HERO"] = "companyHero";
    LivePriceSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    LivePriceSymbolsKeyEnum["TRENDING_STOCK"] = "trendingStock";
    LivePriceSymbolsKeyEnum["CATALOG"] = "catalog";
    LivePriceSymbolsKeyEnum["SECTOR"] = "sector";
    LivePriceSymbolsKeyEnum["WATCHLIST"] = "watchlist";
    LivePriceSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    LivePriceSymbolsKeyEnum["IHSG_WIDGET"] = "ihsgWidget";
    LivePriceSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    LivePriceSymbolsKeyEnum["TRANSACTION_FORM"] = "transactionForm";
    LivePriceSymbolsKeyEnum["TRADE_PAGE"] = "tradePage";
    LivePriceSymbolsKeyEnum["PORTFOLIO_DETAIL"] = "portfolioDetail";
    LivePriceSymbolsKeyEnum["ORDERLIST_DETAIL"] = "orderlistDetail";
    LivePriceSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(LivePriceSymbolsKeyEnum || (LivePriceSymbolsKeyEnum = {}));


/***/ }),

/***/ 7538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XA": function() { return /* binding */ natsLivePriceFormatter; }
/* harmony export */ });
/* unused harmony exports oldLivePriceFormatter, isNatsLivePriceResponse */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var natsLivePriceFormatter = function(liveprice) {
    return {
        // orderbook col 1
        previous: liveprice.prev,
        change: liveprice.change.value,
        percentage_change: liveprice.change.percentage,
        frequency: liveprice.frequency,
        // orderbook col 2
        open: liveprice.open,
        high: liveprice.high,
        low: liveprice.low,
        // fbuy: 0, // Not Exist in LivePrice Nats
        // orderbook col 3
        volume: liveprice.volume,
        value: liveprice.value,
        average: liveprice.average,
        // fsell: 0, // Not Exist in LivePrice Nats
        // misc
        close: liveprice.close,
        lastprice: liveprice.lastprice,
        date: liveprice.date,
        stockCode: liveprice.stockCode
    };
};
var oldLivePriceFormatter = function(param) {
    var ohlc = param.ohlc, widget = param.widget, sym = param.sym;
    return {
        // orderbook col 1
        previous: ohlc.previous,
        change: widget[sym].price_change,
        percentage_change: widget[sym].percentage_change,
        frequency: ohlc.frequency,
        // orderbook col 2
        open: ohlc.Open,
        high: ohlc.High,
        low: ohlc.Low,
        fbuy: ohlc.foreign_buy,
        // orderbook col 3
        volume: ohlc.volume,
        value: ohlc.value,
        average: ohlc.avg_price,
        fsell: ohlc.foreign_sell,
        // misc
        close: ohlc.Close,
        lastprice: widget[sym].lastprice,
        date: ohlc.date_formated ? moment(ohlc.date_formated, "YYYY-MM-DD HH:mm:ss").format() : "",
        stockCode: sym
    };
};
/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ var isNatsLivePriceResponse = function(rawLivePrice) {
    return rawLivePrice.stockCode !== undefined;
}; // Formatted Nats
 // {
 //     "previous": 4710,
 //     "change": -10,
 //     "percentage_change": -0.21231422505307856,
 //     "frequency": 13409,
 //     "open": 4760,
 //     "high": 4770,
 //     "low": 4700,
 //     "volume": 89721000,
 //     "value": 424632501000,
 //     "average": 4733,
 //     "close": 4700,
 //     "lastprice": 4700,
 //     "date": "2023-03-15T15:09:29.728289+07:00",
 //     "stockCode": "BBRI"
 // }
 // Raw Nats
 // {
 //   "stockCode": "GOTO",
 //   "lastprice": 120,
 //   "volume": 2619794600,
 //   "high": 125,
 //   "low": 119,
 //   "open": 124,
 //   "frequency": 20846,
 //   "average": 122,
 //   "date": "2023-03-15T14:48:21.762801+07:00",
 //   "close": 120,
 //   "prev": 121,
 //   "value": 318585803700,
 //   "change": {
 //     "value": -1,
 //     "percentage": -0.8264462809917356
 //   },
 //   "orderVerb": "B",
 //   "quantity": "85200",
 //   "sequenceNumber": "3963134",
 //   "orderBookId": "4311",
 //   "orderNumber": "202303150001779420",
 //   "matchNumber": "202303150001127170",
 //   "board": "BOARD_TYPE_RG"
 // }
 // Raw Old
 // {
 //   "sym": "BBCA",
 //   "date_unix": 1678865974,
 //   "ohlc": {
 //     "Adj_Close": 8350,
 //     "Close": 8350,
 //     "High": 8475,
 //     "Low": 8325,
 //     "Open": 8450,
 //     "volume": 46148300,
 //     "date_unix": 1678865974,
 //     "date_formated": "2023-03-15 14:39:34",
 //     "dividend": 0,
 //     "foreign_buy": 0,
 //     "foreign_flow": 0,
 //     "foreign_sell": 0,
 //     "frequency": 14038,
 //     "marketcap": 0,
 //     "value": 387196490000,
 //     "shareoutstanding": 0,
 //     "ann_eps": 0,
 //     "ann_pe": 0,
 //     "avg_price": 8390,
 //     "previous": 8325,
 //     "freq_analyzer": 0
 //   },
 //   "widget": {
 //     "BBCA": {
 //       "lastprice": 8350,
 //       "price_change": 25,
 //       "percentage_change": 0.3003
 //     }
 //   },
 //   "OFFER-RG": {},
 //   "BID-RG": {},
 //   "__t": "1678865974"
 // }


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLivePriceReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            onMessage(formattedLivePrice, liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 35320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useLivePriceSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _liveprice_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66620);


var useLivePriceSender = function(key, symbols) {
    var setLivePriceSymbols = (0,_liveprice_store__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceStore */ .H)().setLivePriceSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var listSymbol = stringSymbols ? stringSymbols.split(",") : [];
        setLivePriceSymbols(key, listSymbol);
        return function() {
            return setLivePriceSymbols(key, []);
        };
    }, [
        key,
        stringSymbols,
        setLivePriceSymbols
    ]);
};


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 13 modules
var websocket_pb = __webpack_require__(84);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx


















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        (ref = socket.current) === null || ref === void 0 ? void 0 : ref.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 49696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedMessageEffect = function(channel, key, action) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (action) {
            setAction(channel, key, action);
            return function() {
                return removeAction(channel, key);
            };
        }
    }, [
        channel,
        key,
        action
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedMessageEffect);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 5728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ tradingErrorModalList; },
/* harmony export */   "c0": function() { return /* binding */ tradingErrorModalConfig; },
/* harmony export */   "qO": function() { return /* binding */ errorInfoList; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var errorInfoList = [
    {
        error: 401,
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama",
        isLogoutUser: true
    },
    {
        error: 500,
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        isShowButton: true,
        buttonText: "Tutup"
    },
    {
        error: 503,
        imageUrl: "/img/maintenance-mode.svg",
        title: "Maintenance Sedang Berlangsung",
        description: "Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama"
    }, 
];
var tradingErrorModalConfig = {
    sessionExpired: {
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: true,
        isLogoutUser: true
    },
    maintenance: {
        imageUrl: "/img/maintenance-mode.svg",
        title: "Pemeliharaan Sedang Berlangsung",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    dailyMaintenance: {
        imageUrl: "/img/daily-maintenance.svg",
        title: "Persiapan Harian",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    systemError: {
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        buttonText: "Tutup",
        isShowButton: true
    },
    userSuspend: {
        imageUrl: "/img/trading-limit-user-suspended.svg",
        title: "Tidak Dapat Melakukan Transaksi",
        description: "Deposit atau jual saham untuk melakukan transaksi.",
        buttonText: "Deposit Sekarang",
        isShowButton: true,
        redirectTo: "/securities/deposit",
        needToCloseTradingModal: true,
        isFullWidthButton: true
    }
};
var tradingErrorModalList = {
    401: {
        NO_SERVER_RESPONSE: "sessionExpired",
        INVALID_AUTH: "sessionExpired",
        // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
        INVALID_TOKEN: "sessionExpired",
        INVALID_SESSION: "sessionExpired",
        MOCK_TRADING: "sessionExpired",
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance",
        UNAUTHORIZED: "sessionExpired"
    },
    403: {
        USER_SUSPEND: "userSuspend",
        USER_SUSPEND_BACK_OFFICE: "userSuspend"
    },
    503: {
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance"
    },
    500: {
        SYSTEM_ERROR: "systemError"
    }
};


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 6474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ getCashInfo; },
  "S": function() { return /* binding */ getCashOnHand; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/global/Securities/constants/apiEndpoints/balance.ts
var balanceEndpoint = {
    cashInfo: "/balance/cash/info",
    cashOnHand: "/balance/cash"
};
/* harmony default export */ var balance = (balanceEndpoint);

// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/balance.ts




var getCashInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode, orderId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashInfo, {
                        params: {
                            stock_code: stockCode,
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashInfo(stockCode, orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getCashOnHand = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashOnHand));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashOnHand() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18364);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 24949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getOrderDetail; },
/* harmony export */   "k": function() { return /* binding */ bulkCancelByOrderId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4621);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96563);





var bulkCancelByOrderId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderIds) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.bulkCancelByOrderId */ .Li.bulkCancelByOrderId, {
                        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUiRef */ .TW)(),
                        order_id: orderIds
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bulkCancelByOrderId(orderIds) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.orderDetail */ .Li.orderDetail, {
                        params: {
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 76870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65131);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);
/* harmony import */ var global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27934);





var StateKey = {
    trade_page: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.TRADE_PAGE */ .j.TRADE_PAGE,
    portfolio_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.PORTFOLIO_DETAIL */ .j.PORTFOLIO_DETAIL,
    orderlist_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.ORDERLIST_DETAIL */ .j.ORDERLIST_DETAIL
};
var useLivePriceUpdater = function(config, updateFunction) {
    var isRealTrading = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isRealTrading;
    var symbol = config.symbol, page = config.page;
    var symbols = Array.isArray(symbol) ? symbol : [
        symbol
    ];
    (0,global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(StateKey[page], symbols);
    var livePriceOnMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (!isRealTrading) return;
        var isSymbolMatch = Array.isArray(symbol) ? symbol.includes(message.stockCode) : message.stockCode === symbol;
        if (!isSymbolMatch) return;
        updateFunction(message);
    }, [
        symbol,
        isRealTrading,
        updateFunction
    ]);
    (0,global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__/* .useLivePriceReceiver */ .V)(symbols, page, livePriceOnMessage);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLivePriceUpdater);


/***/ }),

/***/ 8948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65906);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91635);







var initialState = {
    status: null
};
var useOpeningAccountStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        resetStore: function() {
            return set({
                status: null
            });
        },
        loadAccountStatus: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res, ref, ref1, data, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_securities__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getOAStatus */ .Z.getOAStatus();
                    case 3:
                        res = _ctx.sent;
                        ;
                        ref1 = (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : {}, data = ref1.data, _$error = ref1.error;
                        if (!(!data || _$error)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get oa status failed");
                    case 8:
                        set({
                            status: data.status
                        });
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ctx.t0, {
                            event: "useOpeningAccountStore@loadAccountStatus",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOpeningAccountStore);


/***/ }),

/***/ 87127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12902);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75413);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24949);








var initialState = {
    data: undefined,
    isLoading: false
};
var useOrderDetailStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetail: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
                var axiosResponse, _data, responseData, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_2__/* .getOrderDetail */ .d)(orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            data = utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__/* ["default"].orderDetail */ .Z.orderDetail(responseData);
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderDetail: function() {
            set(initialState);
        },
        updateOrderDetail: function(newData) {
            var ref;
            if (typeof newData !== "object") return;
            var currentOrderId = (ref = get().data) === null || ref === void 0 ? void 0 : ref.orderid;
            if (currentOrderId !== newData.orderid) return;
            set((0,immer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
                state.data = newData;
            }));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOrderDetailStore);


/***/ }),

/***/ 98976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_usePortfolioDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/portfolio.ts





var getPortfolio = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var targetAPI;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    targetAPI = (0,utils/* getTargetAPI */.Ai)();
                    return _ctx.abrupt("return", trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolio */.Db.portfolio[targetAPI]));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPortfolio() {
        return _ref.apply(this, arguments);
    };
}();
var getPortfolioDetail = function(symbol) {
    var targetAPI = (0,utils/* getTargetAPI */.Ai)();
    return trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolioDetail */.Db.portfolioDetail[targetAPI](symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts








var initialState = {
    data: {},
    dayTrade: {},
    isLoading: false
};
var usePortfolioDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setCurrentSymbol: function(symbol) {
            set({
                data: {
                    symbol: symbol
                }
            });
        },
        loadPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, _data, responseData, result, day_trade, data, dataDaytrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getPortfolioDetail(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            result = responseData.result, day_trade = responseData.day_trade;
                            data = transformData/* default.portfolioItem */.Z.portfolioItem(result);
                            dataDaytrade = transformData/* default.portfolioItem */.Z.portfolioItem(day_trade);
                            set({
                                data: data,
                                dayTrade: dataDaytrade,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetPortfolioDetail: function() {
            set(initialState);
        },
        updatePortfolioDetail: function(newData) {
            var checkSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref;
            if (typeof newData !== "object") return;
            var currentSymbol = (ref = get().data) === null || ref === void 0 ? void 0 : ref.symbol;
            if (currentSymbol !== newData.symbol && checkSymbol) return;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (isDayTrade) {
                    state.dayTrade = (0,_object_spread/* default */.Z)({}, state.dayTrade, newData);
                } else {
                    state.data = (0,_object_spread/* default */.Z)({}, state.data, newData);
                }
            }));
        }
    });
});
/* harmony default export */ var stores_usePortfolioDetailStore = (usePortfolioDetailStore);


/***/ }),

/***/ 75626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ OrderAction; }
/* harmony export */ });
/* unused harmony export OrderStatus */
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ActionTarget; },
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony exports OrderStatus, LeverageType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var LeverageType;
(function(LeverageType) {
    LeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    LeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    LeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    LeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    LeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    LeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(LeverageType || (LeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);
var ActionTarget;
(function(ActionTarget) {
    ActionTarget["UNSPECIFIED"] = "ACTION_TARGET_UNSPECIFIED";
    ActionTarget["REGULAR"] = "ACTION_TARGET_REGULAR";
    ActionTarget["DAY_TRADE"] = "ACTION_TARGET_DAY_TRADE";
    ActionTarget["LEGACY_SMARTORDER"] = "ACTION_TARGET_LEGACY_SMARTORDER";
    ActionTarget["TRAILING_STOP"] = "ACTION_TARGET_TRAILING_STOP";
    ActionTarget["STOP_ORDER"] = "ACTION_TARGET_STOP_ORDER";
    ActionTarget["BRACKET_ORDER"] = "ACTION_TARGET_BRACKET_ORDER";
})(ActionTarget || (ActionTarget = {}));


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSecuritiesContext; },
/* harmony export */   "i": function() { return /* binding */ SecuritiesContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SecuritiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isAuthorized: false,
    token: undefined,
    socket: undefined,
    setChannel: function() {},
    setAction: function() {},
    removeAction: function() {}
});
var useSecuritiesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SecuritiesContext);
    if (context === undefined) {
        throw new Error("useSecuritiesContext must be used within a SecuritiesProvider");
    }
    return context;
};



/***/ }),

/***/ 93313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "Dp": function() { return /* binding */ UPTIME; },
/* harmony export */   "FJ": function() { return /* binding */ SecuritiesMessageCase; },
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "LU": function() { return /* binding */ MAX_POLLING_ATTEMPTS; },
/* harmony export */   "Nl": function() { return /* binding */ HEARTBEAT_FACTOR; },
/* harmony export */   "S0": function() { return /* binding */ DATA_ACTION; },
/* harmony export */   "aG": function() { return /* binding */ RECONNECT_INTERVAL; },
/* harmony export */   "al": function() { return /* binding */ HEARTBEAT_INTERVAL; },
/* harmony export */   "kQ": function() { return /* binding */ ReadyState; },
/* harmony export */   "pm": function() { return /* binding */ MAX_RECONNECT_ATTEMPTS; }
/* harmony export */ });
var RECONNECT_INTERVAL = 30000; // 30 seconds
var HEARTBEAT_INTERVAL = 15000; // 15 seconds
var HEARTBEAT_FACTOR = 1.5; // 1.5 times the heartbeat interval
var MAX_RECONNECT_ATTEMPTS = 3;
var MAX_POLLING_ATTEMPTS = 50;
var UPTIME = 2000; // 2 seconds
var SecuritiesMessageCase = {
    SUMMARY: "portfolioSummary",
    PORTFOLIO_LIST: "portfolioList",
    PORTFOLIO_DETAIL: "portfolioDetail",
    PORTFOLIO_DETAIL_DAY_TRADE: "portfolioDetailDayTrade",
    ORDER_LIST: "orderList",
    ORDER_DETAIL: "orderDetail"
};
var DATA_ACTION = {
    UPSERT: 1,
    DELETE: 2
};
var ERROR_CODE;
(function(ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ERROR_CODE[ERROR_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    ERROR_CODE[ERROR_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));
var ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState || (ReadyState = {}));
var NetworkStatus;
(function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "online";
    NetworkStatus["OFFLINE"] = "offline";
})(NetworkStatus || (NetworkStatus = {}));


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ SecuritiesChannel; },
/* harmony export */   "e7": function() { return /* binding */ PayloadCase; }
/* harmony export */ });
/* unused harmony exports RequestCommand, RequestChannel */
var SecuritiesChannel;
(function(SecuritiesChannel) {
    SecuritiesChannel["PING"] = "ping";
    SecuritiesChannel["AUTH"] = "auth";
    SecuritiesChannel["SECURITIES"] = "securities";
})(SecuritiesChannel || (SecuritiesChannel = {}));
var PayloadCase;
(function(PayloadCase) {
    PayloadCase["COMMAND"] = "command";
    PayloadCase["SUBSCRIBE"] = "subscribe";
    PayloadCase["UNSUBSCRIBE"] = "unsubscribe";
})(PayloadCase || (PayloadCase = {}));
var RequestCommand;
(function(RequestCommand) {
    RequestCommand[RequestCommand["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestCommand[RequestCommand["PING"] = 1] = "PING";
    RequestCommand[RequestCommand["AUTH"] = 2] = "AUTH";
})(RequestCommand || (RequestCommand = {}));
var RequestChannel;
(function(RequestChannel) {
    RequestChannel[RequestChannel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestChannel[RequestChannel["SECURITIES_LIVE_PORTO"] = 1] = "SECURITIES_LIVE_PORTO";
})(RequestChannel || (RequestChannel = {}));


/***/ }),

/***/ 77596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePortfolio; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.types.ts
var securities_store_types = __webpack_require__(17985);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioSender.ts





function usePortfolioSender(allowUnsubscribe) {
    var ref = (0,SecuritiesContext/* useSecuritiesContext */.S)(), setChannel = ref.setChannel, socket = ref.socket, token = ref.token, isAuthorized = ref.isAuthorized;
    var accountNumber = (0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return s.accountNumber;
    });
    var handleAction = (0,react.useCallback)(function(actionType) {
        var isSubscribe = actionType === securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE;
        var channelPayload = isSubscribe ? utils/* default.createSubscribePayload */.ZP.createSubscribePayload(accountNumber) : utils/* default.createUnsubscribePayload */.ZP.createUnsubscribePayload(accountNumber);
        if (socket && accountNumber) {
            setChannel(securities_store_types/* SecuritiesChannel.SECURITIES */.Jd.SECURITIES, channelPayload);
        }
    }, [
        setChannel,
        socket,
        token,
        accountNumber
    ]);
    (0,react.useEffect)(function() {
        if (isAuthorized) {
            handleAction(securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE);
        }
        return function() {
            if (allowUnsubscribe) handleAction(securities_store_types/* PayloadCase.UNSUBSCRIBE */.e7.UNSUBSCRIBE);
        };
    }, [
        isAuthorized,
        handleAction
    ]);
};

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/utils/securities/formatter.ts
var formatter = __webpack_require__(89237);
// EXTERNAL MODULE: ./src/global/Securities/types/store/order.ts
var store_order = __webpack_require__(91037);
;// CONCATENATED MODULE: ./src/utils/securities/transformWebsocketData.ts


var convertSideToAction = function(side) {
    return side === store_order/* iOrderSide.BUY */.vT.BUY ? store_order/* OrderAction.Buy */.iX.Buy : store_order/* OrderAction.Sell */.iX.Sell;
};
var portfolioSummary = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, trading = ref.trading, amount = ref.amount, profitLoss = ref.profitLoss, gain = ref.gain, equity = ref.equity, debt = ref.debt;
    return {
        tradingbalance: trading === null || trading === void 0 ? void 0 : trading.balance,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_allocated: amount === null || amount === void 0 ? void 0 : amount.allocated,
        amount_creditlimit: amount === null || amount === void 0 ? void 0 : amount.creditLimit,
        unrealised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.unrealised,
        realised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.realised,
        profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.net,
        gain: gain,
        equity: equity,
        debt_ratio: debt === null || debt === void 0 ? void 0 : debt.ratio,
        debt_total: debt === null || debt === void 0 ? void 0 : debt.total,
        debt_market_value: debt === null || debt === void 0 ? void 0 : debt.marketValue
    };
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, isSharia = ref.isSharia;
    return {
        allow_order: (0,formatter/* convertBooleanToNumber */.y0)(flags === null || flags === void 0 ? void 0 : flags.allowOrder),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,formatter/* getExercisedData */.a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.haveSmartOrder,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stockOnHand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.marketValue,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profitLoss,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.canBuy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.canSell,
        is_sharia: isSharia
    };
};
var portfolioList = function(portfolio) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref10.summary, smartOrderInfo = ref10.smartOrderInfo, results = ref10.results, dayTrade = ref10.dayTrade;
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : (ref = summary.trading) === null || ref === void 0 ? void 0 : ref.balance,
        amount_invested: summary === null || summary === void 0 ? void 0 : (ref1 = summary.amount) === null || ref1 === void 0 ? void 0 : ref1.invested,
        amount_allocated: summary === null || summary === void 0 ? void 0 : (ref2 = summary.amount) === null || ref2 === void 0 ? void 0 : ref2.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : (ref3 = summary.amount) === null || ref3 === void 0 ? void 0 : ref3.creditLimit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : (ref4 = summary.profitLoss) === null || ref4 === void 0 ? void 0 : ref4.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : (ref5 = summary.profitLoss) === null || ref5 === void 0 ? void 0 : ref5.realised,
        profitloss: summary === null || summary === void 0 ? void 0 : (ref6 = summary.profitLoss) === null || ref6 === void 0 ? void 0 : ref6.net,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        show_create_smartorder: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.canCreate,
        auto_order_info: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.info,
        result: results === null || results === void 0 ? void 0 : results.map(function(result) {
            return portfolioItem(result);
        }),
        day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.map(function(result) {
            return portfolioItem(result);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : (ref7 = summary.debt) === null || ref7 === void 0 ? void 0 : ref7.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : (ref8 = summary.debt) === null || ref8 === void 0 ? void 0 : ref8.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : (ref9 = summary.debt) === null || ref9 === void 0 ? void 0 : ref9.marketValue
    };
};
var orderDetail = function(order) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = order !== null && order !== void 0 ? order : {}, action = ref13.action, amount = ref13.amount, dayTrade = ref13.dayTrade, gtc = ref13.gtc, marketOrderId = ref13.marketOrderId, message = ref13.message, orderId = ref13.orderId, price = ref13.price, qty = ref13.qty, side = ref13.side, smartOrder = ref13.smartOrder, statusText = ref13.statusText, symbol = ref13.symbol, time = ref13.time, isSharia = ref13.isSharia, securitiesKind = ref13.securitiesKind;
    var securities_kind = (0,formatter/* convertSecuritiesKind */.KH)(securitiesKind);
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var platforms = {
        0: store_order/* PlatformOrderTypes.UNSPECIFIED */.F4.UNSPECIFIED,
        1: store_order/* PlatformOrderTypes.LIMIT */.F4.LIMIT,
        2: store_order/* PlatformOrderTypes.FAK */.F4.FAK
    };
    var amendtargets = {
        0: store_order/* ActionTarget.UNSPECIFIED */.BJ.UNSPECIFIED,
        1: store_order/* ActionTarget.REGULAR */.BJ.REGULAR,
        2: store_order/* ActionTarget.DAY_TRADE */.BJ.DAY_TRADE,
        3: store_order/* ActionTarget.LEGACY_SMARTORDER */.BJ.LEGACY_SMARTORDER,
        4: store_order/* ActionTarget.TRAILING_STOP */.BJ.TRAILING_STOP,
        5: store_order/* ActionTarget.STOP_ORDER */.BJ.STOP_ORDER,
        6: store_order/* ActionTarget.BRACKET_ORDER */.BJ.BRACKET_ORDER
    };
    return {
        action: convertSideToAction(side),
        amend_action: action.canAmend,
        amend_target: amendtargets[action.amendTarget],
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matchedTotal,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action.canCancel,
        cancel_target: amendtargets[action.cancelTarget],
        config_type: (0,formatter/* convertSmartOrderConfigType */.Hc)(smartOrder === null || smartOrder === void 0 ? void 0 : (ref1 = smartOrder.configType) === null || ref1 === void 0 ? void 0 : ref1.toString()),
        gtc: (0,formatter/* convertBooleanToNumber */.y0)(gtc === null || gtc === void 0 ? void 0 : gtc.isGtc),
        label: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.label,
        market_orderid: marketOrderId,
        message: message,
        order_done: qty === null || qty === void 0 ? void 0 : qty.lotDone,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lotOpen,
        order_total: qty === null || qty === void 0 ? void 0 : qty.lotTotal,
        orderid: orderId,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.orderId,
        status: statusText,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,formatter/* getHourFromTimestamp */.aF)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        time_match: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.match)),
        time_open: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        trigger_price: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.triggerPrice,
        day_trade_is_day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.isDayTrade,
        day_trade_force_sell_event: (0,formatter/* convertForceSellEvent */.zn)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.forceSellEvent),
        day_trade_message: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.message,
        is_sharia: isSharia,
        trailing_stop: (smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.trailingStop) ? {
            id: (smartOrder === null || smartOrder === void 0 ? void 0 : (ref2 = smartOrder.trailingStop) === null || ref2 === void 0 ? void 0 : ref2.id.toString()) || "",
            price_algorithm: {
                type: smartOrder === null || smartOrder === void 0 ? void 0 : (ref3 = smartOrder.trailingStop) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.priceAlgorithm) === null || ref4 === void 0 ? void 0 : ref4.type,
                value: smartOrder === null || smartOrder === void 0 ? void 0 : (ref5 = smartOrder.trailingStop) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.priceAlgorithm) === null || ref6 === void 0 ? void 0 : ref6.value
            },
            stop_price: {
                currency_code: smartOrder === null || smartOrder === void 0 ? void 0 : (ref7 = smartOrder.trailingStop) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.stopPrice) === null || ref8 === void 0 ? void 0 : ref8.currencyCode,
                units: smartOrder === null || smartOrder === void 0 ? void 0 : (ref9 = smartOrder.trailingStop) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.stopPrice) === null || ref10 === void 0 ? void 0 : ref10.units.toString(),
                nanos: smartOrder === null || smartOrder === void 0 ? void 0 : (ref11 = smartOrder.trailingStop) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.stopPrice) === null || ref12 === void 0 ? void 0 : ref12.nanos
            }
        } : null,
        platform_order_type: platforms[order.platformOrderType]
    };
};
var orderList = function(response) {
    var orders = (response !== null && response !== void 0 ? response : {}).orders;
    return orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
};
/* harmony default export */ var transformWebsocketData = ({
    portfolioSummary: portfolioSummary,
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList
});

;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useSecuritiesMessage.ts


var useSecuritiesMessage = function(channel, action) {
    var allowUnsubscribe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var ref = (0,react.useContext)(SecuritiesContext/* SecuritiesContext */.i), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react.useEffect)(function() {
        if (action) {
            setAction(channel, action);
            return function() {
                if (allowUnsubscribe) {
                    removeAction(channel);
                }
            };
        }
        return undefined;
    }, [
        channel,
        action,
        setAction,
        removeAction,
        allowUnsubscribe
    ]);
};
/* harmony default export */ var hooks_useSecuritiesMessage = (useSecuritiesMessage);

// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioReceiver.ts








function usePortfolioReceiver() {
    var allowUnsubscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref = (0,tradingData/* default */.Z)(function(s) {
        return {
            updatePortfolioSummary: s.updatePortfolioSummary,
            updatePortfolioList: s.updatePortfolioList,
            updatePortfolioItem: s.updatePortfolioItem,
            deletePortfolioListItem: s.deletePortfolioItem,
            updateOrderList: s.updateOrderList,
            updateOrderListItem: s.updateOrderListItem,
            deleteOrderListItem: s.deleteOrderListItem
        };
    }, shallow/* default */.Z), updatePortfolioSummary = ref.updatePortfolioSummary, updatePortfolioList = ref.updatePortfolioList, updatePortfolioItem = ref.updatePortfolioItem, deletePortfolioListItem = ref.deletePortfolioListItem, updateOrderList = ref.updateOrderList, updateOrderListItem = ref.updateOrderListItem, deleteOrderListItem = ref.deleteOrderListItem;
    var updatePortfolioDetail = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            updatePortfolioDetail: s.updatePortfolioDetail
        };
    }, shallow/* default */.Z).updatePortfolioDetail;
    var updateOrderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return {
            updateOrderDetail: s.updateOrderDetail
        };
    }, shallow/* default */.Z).updateOrderDetail;
    var handleReceiveMessage = (0,react.useCallback)(function(param) {
        var messageAction = param.action, message = param.message;
        if (!message) return;
        switch(message.case){
            case constants/* SecuritiesMessageCase.SUMMARY */.FJ.SUMMARY:
                {
                    var transformedData = transformWebsocketData.portfolioSummary(message.value);
                    updatePortfolioSummary(transformedData);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_LIST */.FJ.PORTFOLIO_LIST:
                {
                    var transformedData1 = transformWebsocketData.portfolioList(message.value);
                    updatePortfolioList(transformedData1);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL */.FJ.PORTFOLIO_DETAIL:
                {
                    var transformedData2 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData2.symbol);
                        break;
                    }
                    updatePortfolioDetail(transformedData2);
                    updatePortfolioItem(transformedData2.symbol, transformedData2);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL_DAY_TRADE */.FJ.PORTFOLIO_DETAIL_DAY_TRADE:
                {
                    var transformedData3 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData3.symbol, true);
                        break;
                    }
                    updatePortfolioDetail(transformedData3, true, true);
                    updatePortfolioItem(transformedData3.symbol, transformedData3, true);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_LIST */.FJ.ORDER_LIST:
                {
                    var transformedData4 = transformWebsocketData.orderList(message.value);
                    updateOrderList(transformedData4);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_DETAIL */.FJ.ORDER_DETAIL:
                {
                    var transformedData5 = transformWebsocketData.orderDetail(message.value);
                    updateOrderListItem(transformedData5.orderid, transformedData5);
                    updateOrderDetail(transformedData5);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deleteOrderListItem(transformedData5.orderid);
                    }
                    break;
                }
            default:
                break;
        }
    }, []);
    hooks_useSecuritiesMessage("securities", handleReceiveMessage, allowUnsubscribe);
};

;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts


var useGenPortfolio = function() {
    var allowUnsubscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    usePortfolioSender(allowUnsubscribe);
    usePortfolioReceiver(allowUnsubscribe);
};
/* harmony default export */ var usePortfolio = (useGenPortfolio);


/***/ }),

/***/ 46238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c$": function() { return /* binding */ createPingPayload; },
/* harmony export */   "y_": function() { return /* binding */ generateWSCookie; }
/* harmony export */ });
/* unused harmony exports getAccountNumber, createUint8Array, createSubscribePayload, createUnsubscribePayload */
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11763);
/* harmony import */ var _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17985);


var getAccountNumber = function() {
    var accountNumber = securitiesLocalStorage.getSecuritiesAccountInfo().accountNumber;
    return accountNumber !== null && accountNumber !== void 0 ? accountNumber : null;
};
var createUint8Array = function(value) {
    var textEncoder = new TextEncoder();
    return textEncoder.encode(value);
};
var createPingPayload = function() {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.COMMAND */ .e7.COMMAND,
            value: 1
        },
        value: new Uint8Array()
    };
};
var createSubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.SUBSCRIBE */ .e7.SUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var createUnsubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.UNSUBSCRIBE */ .e7.UNSUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var generateWSCookie = function(value) {
    return "gen-websocket=".concat(value, "; domain=stockbit.com; path=/v1; Secure;");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createPingPayload: createPingPayload,
    createSubscribePayload: createSubscribePayload,
    createUnsubscribePayload: createUnsubscribePayload,
    generateWSCookie: generateWSCookie
});


/***/ }),

/***/ 29541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useBondOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);






var initialState = {
    selected: undefined,
    list: [],
    isLoading: false,
    isLoadingList: false
};
var useBondOrder = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetails: function loadOrderDetails(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var list, index, response, _data, order;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            list = get().list;
                            index = list.findIndex(function(data) {
                                return data.id === id;
                            });
                            if (!(index >= 0)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                selected: list[index],
                                isLoading: false
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderDetail */ .iC)(id);
                        case 9:
                            response = _ctx.sent;
                            _data = response.data, order = _data.data.order;
                            set({
                                selected: order,
                                isLoading: false
                            });
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        loadOrderList: function loadOrderList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, _data, orders;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderList */ .R0)();
                        case 4:
                            response = _ctx.sent;
                            _data = response.data, orders = _data.data.orders;
                            set({
                                list: orders,
                                isLoadingList: false
                            });
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false
                            });
                            Promise.reject(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        clearSelected: function clearSelected() {
            set({
                selected: null
            });
        },
        clearList: function clearList() {
            set({
                list: []
            });
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .Z.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 42427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useBondPreviewStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);







var initialState = {
    buy: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialBuyPreview */ .dX,
    sell: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialSellPreview */ .Bv,
    product: undefined,
    isLoading: false
};
var useBondPreviewStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadBuyPreview: /**
   * We override the response when receive unit value <= 0
   *
   * This behavior is needed to provide the initial value of the buy modal
   *
   * We will show the 0 values to the user,
   *    except the buy price `price_rate` value.
   *
   */ function loadBuyPreview(productId) {
            var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().buy.price_rate;
                            if (!(isZeroUnit && priceRate)) {
                                _ctx.next = 6;
                                break;
                            }
                            set({
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: priceRate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 6:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondBuyPreview */ .UU)({
                                product_id: productId,
                                /**
         * We will set the unit to 1 if the unit is 0 or negative value
         * So it will still calls the API without any errors
         */ unit: isZeroUnit ? 1 : unit
                            });
                        case 9:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 14;
                                break;
                            }
                            set({
                                // we store the product information
                                product: data.product,
                                isLoading: false,
                                // override response
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: data.price_rate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 14:
                            set({
                                buy: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 21;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                product: initialState.product,
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadSellPreview: function loadSellPreview(productId, acquisitionOrderId) {
            var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, availableUnit, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().sell.price.sell;
                            availableUnit = get().sell.available_units;
                            if (!(isZeroUnit && priceRate && availableUnit)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    available_units: availableUnit,
                                    // exception, price.sell is needed to show the selling price
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        sell: priceRate
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            if (productId) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Product Code is required");
                        case 9:
                            if (acquisitionOrderId) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error("Order id is required");
                        case 11:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 14;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondSellPreview */ .QY)({
                                product_id: productId,
                                acquisition_order_id: acquisitionOrderId,
                                unit: isZeroUnit ? 1 : unit
                            });
                        case 14:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 19;
                                break;
                            }
                            set({
                                product: data.product,
                                isLoading: false,
                                // override the sell preview response with initial state
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    // exception, available unit
                                    available_units: data.available_units,
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        // except the price sell data
                                        sell: data.price.sell
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 19:
                            set({
                                sell: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 26;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useBondTransaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73921);
/* harmony import */ var _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78311);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42427);









var initialState = {
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    productId: "",
    unit: 0,
    acquisitionOrderId: "",
    priceRate: 0,
    isLoading: false,
    isTnCAccepted: false,
    isSuccess: false
};
var useBondTransaction = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialState), {
        submitOrder: function submitOrder() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, isTnCAccepted, transactionType, acquisitionOrderId, buy, sell;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            ref = get(), isTnCAccepted = ref.isTnCAccepted, transactionType = ref.transactionType, acquisitionOrderId = ref.acquisitionOrderId;
                            if (isTnCAccepted) {
                                _ctx.next = 5;
                                break;
                            }
                            throw new Error("Terms and Condition is required");
                        case 5:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY)) {
                                _ctx.next = 9;
                                break;
                            }
                            buy = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().buy;
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondBuy */ .yt)({
                                price_rate: buy.price_rate,
                                product_id: buy.product.id,
                                unit: parseInt(buy.unit, 10)
                            });
                        case 9:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL)) {
                                _ctx.next = 13;
                                break;
                            }
                            sell = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().sell;
                            _ctx.next = 13;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondSell */ .OF)({
                                product_id: sell.product.id,
                                buy_order_id: acquisitionOrderId,
                                unit: sell.units,
                                price_rate: sell.price.sell
                            });
                        case 13:
                            // inform the ui layer that the transaction is success
                            set({
                                isLoading: false,
                                isSuccess: true
                            });
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                isSuccess: false
                            });
                            Promise.reject(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }))();
        },
        clearData: function clearData() {
            set(initialState);
        },
        setTnC: function setTnC(value) {
            set({
                isTnCAccepted: value
            });
        },
        initiateBuyTransaction: function initiateBuyTransaction(productId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadBuyPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadBuyPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadBuyPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadBuyPreview(productId)
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        initiateSellTransaction: function initiateSellTransaction(productId, acquisitionOrderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadSellPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadSellPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadSellPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                acquisitionOrderId: acquisitionOrderId,
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadSellPreview(productId, acquisitionOrderId, 1), 
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        reInitiateTransaction: function reInitiateTransaction() {
            set({
                unit: 0,
                priceRate: 0,
                isTnCAccepted: false,
                isSuccess: false
            });
        }
    });
});


/***/ }),

/***/ 81557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBondsModalStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73921);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);
/* harmony import */ var _useBondOrder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29541);
/* harmony import */ var _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29176);
/* harmony import */ var _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55847);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42427);












var initialState = {
    isLoading: false,
    error: undefined,
    isSearchActive: false,
    isAllowedToSearch: false,
    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED,
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondsModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, initialState), {
        toggleSearch: function toggleSearch(state) {
            if (typeof state === "boolean") {
                set({
                    isSearchActive: state
                });
                return;
            }
            set(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), {
                    isSearchActive: !prev.isSearchActive
                });
            });
        },
        openConfirmModal: function openConfirmModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
            });
        },
        openBlockerModal: function openBlockerModal(blockerType) {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                blockerType: blockerType
            });
        },
        openTncModal: function openTncModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC
            });
        },
        openCouponReceipt: function openCouponReceipt(orderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, couponHistories, loadPortfolioDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState(), couponHistories = ref.couponHistories, loadPortfolioDetails = ref.loadPortfolioDetails;
                            if (couponHistories) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return loadPortfolioDetails(orderId, true);
                        case 4:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.COUPON_RECEIPT */ ._y.COUPON_RECEIPT
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderModal: function openOrderModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER */ ._y.ORDER
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderHistoryModal: function openOrderHistoryModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.HISTORY */ ._y.HISTORY
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openBuyModal: function openBuyModal(productId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateBuyTransaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            initiateBuyTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateBuyTransaction;
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.BUY */ .qB.BUY,
                                isAllowedToSearch: true,
                                sourcePage: sourcePage
                            });
                            _ctx.next = 5;
                            return initiateBuyTransaction(productId);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        openSellModal: function openSellModal(productId, orderId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateSellTransaction, loadPortfolioDetails, transactions, _transactions, transaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            // store the source page
                            if (sourcePage) {
                                set({
                                    sourcePage: sourcePage
                                });
                            }
                            if (!orderId) {
                                _ctx.next = 8;
                                break;
                            }
                            initiateSellTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateSellTransaction;
                            _ctx.next = 6;
                            return initiateSellTransaction(productId, orderId);
                        case 6:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
                                isAllowedToSearch: false
                            });
                            return _ctx.abrupt("return");
                        case 8:
                            loadPortfolioDetails = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().loadPortfolioDetails;
                            _ctx.next = 11;
                            return loadPortfolioDetails(productId);
                        case 11:
                            transactions = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().transactions;
                            if (!(transactions.length === 1)) {
                                _ctx.next = 19;
                                break;
                            }
                            _transactions = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(transactions, 1), transaction = _transactions[0];
                            if (!transaction.is_stable_earn) {
                                _ctx.next = 17;
                                break;
                            }
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                                blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.STABLE_EARN */ .Ew.STABLE_EARN
                            });
                            return _ctx.abrupt("return");
                        case 17:
                            get().openSellModal(productId, transaction.order_code);
                            return _ctx.abrupt("return");
                        case 19:
                            // open the assets / product selection modal
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ASSETS */ ._y.ASSETS
                            });
                            _ctx.next = 25;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        openOrderPlacedModal: function openOrderPlacedModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER_PLACED */ ._y.ORDER_PLACED
            });
        },
        reOpenTransactionModal: function reOpenTransactionModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
            });
        },
        closeModal: function closeModal() {
            var ref = get(), modalType = ref.modalType, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            if (isSearchActive) {
                toggleSearch();
            }
            if (modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC) {
                // back to confirmation
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
                });
                return;
            }
            // back to the transaction
            var product = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState().product;
            var isBackToTransaction = modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION;
            if (isBackToTransaction && product) {
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
                });
                return;
            }
            // Close the modal
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED
            });
        },
        closeTransactionModal: function closeTransactionModal() {
            var ref = get(), closeModal = ref.closeModal, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            var clearData = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().clearData;
            var ref1 = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState(), clearPreview = ref1.clear;
            var clearPortfolioList = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().clearPortfolioList;
            if (isSearchActive) {
                toggleSearch();
            }
            clearPreview();
            clearPortfolioList();
            clearData();
            closeModal();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 78311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCashOnHandStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    cashOnHand: 0,
    isLoading: false
};
var useCashOnHandStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadBalance: function loadBalance() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashOnHand */ .S)();
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                cashOnHand: data.available_cash_on_hand
                            });
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 47060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66940);





var useSyariah = function() {
    var setModalState = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.setModalState;
    });
    var checkStockTradable = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(s) {
        return s.checkStockTradable;
    });
    var isUserSyariah = (0,global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var checkSyariahTradeableStatus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return checkStockTradable(symbol);
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.is_sharia_tradable);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function checkSyariahTradeableStatus(symbol) {
            return _ref.apply(this, arguments);
        };
    }();
    var showSyariahRestrictionModal = function() {
        setModalState({
            visible: true,
            modalData: {
                showShariaRestrictionBuy: true
            }
        });
    };
    var hideSyariahRestrictionModal = function() {
        setModalState({
            modalData: {
                showShariaRestrictionBuy: false
            }
        });
    };
    return {
        showSyariahRestrictionModal: showSyariahRestrictionModal,
        hideSyariahRestrictionModal: hideSyariahRestrictionModal,
        checkSyariahTradeableStatus: checkSyariahTradeableStatus,
        isUserSyariah: isUserSyariah
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSyariah);


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page",
    chartbit: "Chartbit"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 1349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78372);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);








var marketDetectorURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/marketdetectors");
var findataViewURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/marketdetectors");
var seasonalityURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/seasonality");
var emittenURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten");
var hotlistURL = "".concat(emittenURL, "/hotlist");
var companyPriceFeedURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed");
var emittenMetadataURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten-metadata");
var orderTradeURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/order-trade");
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].noAlert */ .Z.noAlert;
// trending
var getTrendingCompany = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/trending"));
};
var getIHSG = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/IHSG/info"));
};
var getTendingCompanyPrices = function(param) {
    var symbol = param.symbol, _interval = param.interval, interval = _interval === void 0 ? "5" : _interval;
    if (typeof symbol === "string") {
        return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
            params: {
                interval: interval,
                symbol: symbol
            }
        });
    }
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
        params: {
            interval: interval,
            symbol: symbol
        },
        paramsSerializer: function(params) {
            return qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
        }
    });
};
// Hotlist
var getTopGainer = function() {
    return requestExodus.get("".concat(hotlistURL, "/topgainer?limit=10"));
};
var getTopLoser = function() {
    return requestExodus.get("".concat(hotlistURL, "/toploser?limit=10"));
};
var getMostActive = function() {
    return requestExodus.get("".concat(hotlistURL, "/mostactive?limit=10"));
};
/**
 * Search company with keyword
 */ var getSearchCompany = function(params) {
    return requestExodus.get("/watchlist/search/company", {
        params: params
    });
};
var getCompanyInfo = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyProfile = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/profile"));
};
var getCompanyChart = function(symbol, timeframe) {
    var includePrevious = timeframe === "ytd" || timeframe === "1w";
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol, "/daily"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            timeframe: timeframe
        }, includePrevious && {
            is_include_previous_historical: true
        })
    });
};
var getMarketDetector = function(symbol, params) {
    return requestExodus.get("".concat(marketDetectorURL, "/").concat(symbol), {
        params: params
    });
};
var getTopBroker = function(params) {
    return requestExodus.get("order-trade/broker/top", {
        params: params
    });
};
var getBrokerList = function(params) {
    return requestExodus.get("".concat(findataViewURL, "/brokers"), {
        params: params
    });
};
var getMarketDetectorActivity = function(brokerCode, params) {
    return requestExodus.get("".concat(findataViewURL, "/activity/").concat(brokerCode, "/detail"), {
        params: params
    });
};
var getAllCorpAction = function(symbol) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(symbol), {
        params: {
            limit: limit
        }
    });
};
var getCompanyCorpAction = function(symbol, category) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(category), {
        params: {
            symbol: symbol
        }
    });
};
/**
 * Get company major holder, related to get company insider
 * @param {Object} props
 * @param {string=} props.insider
 * @param {string} props.symbol
 * @param {string=} props.datestart
 * @param {string=} props.dateend
 * @param {number=} props.page
 * @returns {APIResponse}
 */ var getCompanyMajorholder = function(param) {
    var _insider = param.insider, insider = _insider === void 0 ? "" : _insider, symbol = param.symbol, _datestart = param.datestart, datestart = _datestart === void 0 ? "" : _datestart, _dateend = param.dateend, dateend = _dateend === void 0 ? "" : _dateend, page = param.page;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/insider/company/majorholder"), {
        params: {
            insider: insider,
            symbol: symbol,
            date_start: datestart,
            date_end: dateend,
            page: page
        }
    });
};
/**
 * Get company seasonality data
 * @param {string} symbol
 * @param {string|number} year
 * @param {string|number} backyear
 * @return {APIResponse}
 */ var getCompanySeasonality = function(symbol, year, backyear) {
    return requestExodus.get("".concat(seasonalityURL, "/").concat(symbol), {
        params: {
            year: year,
            back_year: backyear
        }
    });
};
var getCompanyKeystat = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/keystats/ratio/v1/").concat(symbol), {
        params: {
            year_limit: 10
        }
    });
};
/**
 * Get financial reports
 * @param {Object} params
 * @param {string} params.symbol
 * @param {string} params.datatype
 * @param {string} params.reporttype
 * @param {string} params.statement
 * @return {APIResponse}
 */ var getFinancialReport = function(param) {
    var symbol = param.symbol, _datatype = param.datatype, datatype = _datatype === void 0 ? 1 : _datatype, reporttype = param.reporttype, statement = param.statement;
    var url = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/company/financial");
    return requestExodus.get(url, {
        params: {
            symbol: symbol,
            data_type: datatype,
            report_type: reporttype,
            statement_type: statement
        }
    }).then(function(res) {
        var newRes = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data);
        newRes.data.defaultCurrency = newRes.data.default_currency;
        newRes.data.htmlReport = newRes.data.html_report;
        newRes.data.rounding_value = {
            idr: newRes.data.rounding_value[0],
            usd: newRes.data.rounding_value[1]
        };
        delete newRes.data.default_currency;
        delete newRes.data.html_report;
        return newRes;
    });
};
/**
 * Get Analyst Rating
 * @param {string} symbol
 * @return {APIResponse}
 */ var getAnalystRating = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol));
};
var getAnalystConsensus = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol, "/consensus"));
};
var getCompanyHoldingCompositionToken = function() {
    return requestExodus.post("".concat(emittenMetadataURL, "/shareholders/token"));
};
var getCompanyHoldingComposition = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, type, timeframe, token, isFromWebview, _tries, tries, getToken, Authorization, res, ref, ref1, statusCode, newToken;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol, type = param.type, timeframe = param.timeframe, token = param.token, isFromWebview = param.isFromWebview, _tries = param.tries, tries = _tries === void 0 ? 0 : _tries;
                    getToken = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var ref, tokenResponse, data;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return getCompanyHoldingCompositionToken();
                                    case 3:
                                        tokenResponse = _ctx.sent;
                                        data = tokenResponse.data;
                                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.value);
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function getToken() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t1 = token;
                    if (_ctx.t1) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t2 = !isFromWebview;
                    if (!_ctx.t2) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 8;
                    return getToken();
                case 8:
                    _ctx.t2 = _ctx.sent;
                case 9:
                    _ctx.t1 = _ctx.t2;
                case 10:
                    _ctx.t0 = _ctx.t1;
                    if (_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t0 = "";
                case 13:
                    Authorization = _ctx.t0;
                    _ctx.prev = 14;
                    if (Authorization) {
                        _ctx.next = 17;
                        break;
                    }
                    throw Error("No Access Token found");
                case 17:
                    _ctx.next = 19;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(emittenMetadataURL, "/shareholders/").concat(symbol, "/chart"), {
                        params: {
                            symbol: symbol,
                            value_year: timeframe,
                            shareholder_type: type
                        },
                        headers: {
                            Authorization: Authorization
                        }
                    });
                case 19:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 23:
                    _ctx.prev = 23;
                    _ctx.t3 = _ctx["catch"](14);
                    ;
                    ;
                    statusCode = (ref1 = _ctx.t3 === null || _ctx.t3 === void 0 ? void 0 : (ref = _ctx.t3.cause) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : 401;
                    if (!(isFromWebview || statusCode !== 401 || tries >= 2)) {
                        _ctx.next = 30;
                        break;
                    }
                    throw _ctx.t3;
                case 30:
                    _ctx.next = 32;
                    return getToken();
                case 32:
                    newToken = _ctx.sent;
                    return _ctx.abrupt("return", getCompanyHoldingComposition({
                        symbol: symbol,
                        type: type,
                        timeframe: timeframe,
                        isFromWebview: isFromWebview,
                        token: newToken,
                        tries: tries + 1
                    }));
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                23
            ]
        ]);
    }));
    return function getCompanyHoldingComposition(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get company contact
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyContact = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/contact"));
};
var getTradeBook = function(params) {
    return requestExodus.get("".concat(orderTradeURL, "/trade-book"), {
        params: params
    });
};
var getInitRunningTrade = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/running-trade"), {
        params: params
    });
};
var getInitRunningTradeV2 = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/v2/running-trade"), {
        params: params
    });
};
var getCompanySubsidiary = function(symbol) {
    return requestExodus.get("".concat(emittenMetadataURL, "/subsidiary/").concat(symbol));
};
var getCompanyInfoV2 = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getCompanyChartV2 = function(symbol, timeframe) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getCompanyFinItem = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
var getGuestCompanyV2 = function(symbol, exchange) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getGuestCompanyChartV2 = function(symbol, timeframe) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getGuestCompanyFinItem = function(symbol, exchange) {
    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
var getStockConversion = function(param) {
    var symbol = param.symbol, page = param.page, limit = param.limit;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(symbol, "/stock_conversion"), {
        params: {
            page: page,
            limit: limit
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTrendingCompany: getTrendingCompany,
    getIHSG: getIHSG,
    getTendingCompanyPrices: getTendingCompanyPrices,
    getSearchCompany: getSearchCompany,
    getCompanyProfile: getCompanyProfile,
    getCompanyInfo: getCompanyInfo,
    getCompanyChart: getCompanyChart,
    getAnalystRating: getAnalystRating,
    getAnalystConsensus: getAnalystConsensus,
    getCompanyContact: getCompanyContact,
    getCompanyInfoV2: getCompanyInfoV2,
    getCompanyChartV2: getCompanyChartV2,
    getCompanyFinItem: getCompanyFinItem,
    // Hotlist
    getTopGainer: getTopGainer,
    getTopLoser: getTopLoser,
    getMostActive: getMostActive,
    // bandar detector
    getMarketDetector: getMarketDetector,
    getBrokerList: getBrokerList,
    getMarketDetectorActivity: getMarketDetectorActivity,
    getTopBroker: getTopBroker,
    // related to profile APIs
    getCompanyCorpAction: getCompanyCorpAction,
    getCompanyMajorholder: getCompanyMajorholder,
    getCompanySeasonality: getCompanySeasonality,
    getCompanyKeystat: getCompanyKeystat,
    getFinancialReport: getFinancialReport,
    getAllCorpAction: getAllCorpAction,
    getStockConversion: getStockConversion,
    // used for trading modal
    getCompanyHoldingCompositionToken: getCompanyHoldingCompositionToken,
    getCompanyHoldingComposition: getCompanyHoldingComposition,
    // Company Price Feed,
    getTradeBook: getTradeBook,
    getInitRunningTrade: getInitRunningTrade,
    getCompanySubsidiary: getCompanySubsidiary,
    getInitRunningTradeV2: getInitRunningTradeV2,
    getGuestCompanyV2: getGuestCompanyV2,
    getGuestCompanyChartV2: getGuestCompanyChartV2,
    getGuestCompanyFinItem: getGuestCompanyFinItem
});


/***/ }),

/***/ 66350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ errorHandler; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);

var errorHandler = function(error, defaultMessage) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
        throw new Error(error.message);
    }
    if (typeof error === "string") {
        throw new Error(error);
    }
    throw new Error(defaultMessage);
};


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "TQ": function() { return /* binding */ lotFormatter; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};
var lotFormatter = function(value) {
    return Intl.NumberFormat("en-US").format(value);
};


/***/ }),

/***/ 75413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export convertSideToAction */
/* harmony import */ var utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89237);
/* harmony import */ var global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75626);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91037);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2078);





var convertSideToAction = function(side) {
    return side === global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__/* .OrderSide.Buy */ .oU.Buy ? global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .i.Buy : global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .i.Sell;
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, type = ref.type, info = ref.info, bond = ref.bond, can_create_smart_order = ref.can_create_smart_order, is_sharia = ref.is_sharia;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(flags === null || flags === void 0 ? void 0 : flags.allow_order),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getExercisedData */ .a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.have_smart_order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stock_on_hand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.market_value,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profit_loss,
        type: type !== null && type !== void 0 ? type : "",
        info: info !== null && info !== void 0 ? info : [],
        bond: bond !== null && bond !== void 0 ? bond : undefined,
        show_create_smartorder: can_create_smart_order !== null && can_create_smart_order !== void 0 ? can_create_smart_order : false,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.can_buy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.can_sell,
        is_sharia: is_sharia
    };
};
var portfolioItemFromBonds = function(data) {
    var ref, ref1, ref2, ref3;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(true),
        amount_invested: data === null || data === void 0 ? void 0 : data.invested_amount,
        available_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        available_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        company_name: data.product.name,
        exercise_data: undefined,
        exercise_type: undefined,
        have_smartorder: false,
        price_average: data === null || data === void 0 ? void 0 : data.price_rate,
        price_average_fee: data === null || data === void 0 ? void 0 : data.price_rate,
        price_latest: undefined,
        stock_on_hand: data === null || data === void 0 ? void 0 : data.invested_amount,
        symbol: data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.identifier,
        total: data === null || data === void 0 ? void 0 : data.total_portfolio,
        unrealised_gain: (data === null || data === void 0 ? void 0 : (ref1 = data.profit_loss) === null || ref1 === void 0 ? void 0 : ref1.percentage) / 100,
        unrealised_marketvalue: data === null || data === void 0 ? void 0 : data.market_value,
        unrealised_profitloss: data === null || data === void 0 ? void 0 : (ref2 = data.profit_loss) === null || ref2 === void 0 ? void 0 : ref2.amount,
        type: constants_trading__WEBPACK_IMPORTED_MODULE_3__/* .STOCK_TYPE.bond */ .L2.bond,
        info: undefined,
        bond: undefined,
        show_create_smartorder: false,
        bond_sell_enabled: parseInt(data === null || data === void 0 ? void 0 : data.units, 10) > 0,
        is_sharia: data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.is_sharia,
        can_buy: false,
        can_sell: false
    };
};
var portfolioList = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref.summary, smart_order_info = ref.smart_order_info, stockPortfolios = ref.results, day_trade = ref.day_trade;
    var result = stockPortfolios.map(function(stockPortfolio) {
        return portfolioItem(stockPortfolio);
    });
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : summary.trading.balance,
        amount_allocated: summary === null || summary === void 0 ? void 0 : summary.amount.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : summary.amount.credit_limit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.realised,
        show_create_smartorder: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.can_create,
        auto_order_info: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.info,
        day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.map(function(item) {
            return portfolioItem(item);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : summary.debt.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : summary.debt.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : summary.debt.market_value,
        amount_invested: summary === null || summary === void 0 ? void 0 : summary.amount.invested,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.net,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        result: result
    };
};
var orderDetail = function(order) {
    var ref;
    var ref1 = order !== null && order !== void 0 ? order : {}, action = ref1.action, amount = ref1.amount, day_trade = ref1.day_trade, gtc = ref1.gtc, market_order_id = ref1.market_order_id, message = ref1.message, order_id = ref1.order_id, price = ref1.price, qty = ref1.qty, side = ref1.side, securities_kind = ref1.securities_kind, smart_order = ref1.smart_order, status_text = ref1.status_text, symbol = ref1.symbol, time = ref1.time, is_sharia = ref1.is_sharia, platform_order_type = ref1.platform_order_type;
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var isFAK = platform_order_type === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__/* .PlatformOrderTypes.FAK */ .F4.FAK;
    var gtc_text = "DAY";
    if (isFAK) gtc_text = "FAK";
    else if (gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc) gtc_text = "GTC";
    var ref2, ref3, ref4, ref5, ref6;
    return {
        action: convertSideToAction(side),
        amend_action: action === null || action === void 0 ? void 0 : action.can_amend,
        amend_target: action === null || action === void 0 ? void 0 : action.amend_target,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: isBond ? undefined : amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matched_total,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action === null || action === void 0 ? void 0 : action.can_cancel,
        cancel_target: action === null || action === void 0 ? void 0 : action.cancel_target,
        config_type: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertSmartOrderConfigType */ .Hc)(smart_order === null || smart_order === void 0 ? void 0 : smart_order.config_type),
        gtc_text: gtc_text,
        gtc: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc),
        label: isFAK ? "MO" : smart_order === null || smart_order === void 0 ? void 0 : smart_order.label,
        market_orderid: market_order_id,
        message: message,
        order_done: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_done,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lot_open,
        order_total: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_total,
        orderid: order_id,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_average_portfolio: price === null || price === void 0 ? void 0 : price.average.portfolio,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: (ref2 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.order_id) !== null && ref2 !== void 0 ? ref2 : smart_order === null || smart_order === void 0 ? void 0 : smart_order.id,
        status: status_text,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getHourFromTimestamp */ .aF)((ref3 = time === null || time === void 0 ? void 0 : time.open) !== null && ref3 !== void 0 ? ref3 : time === null || time === void 0 ? void 0 : time.opened_at),
        time_match: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref4 = time === null || time === void 0 ? void 0 : time.match) !== null && ref4 !== void 0 ? ref4 : time === null || time === void 0 ? void 0 : time.matched_at),
        time_open: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref5 = time === null || time === void 0 ? void 0 : time.open) !== null && ref5 !== void 0 ? ref5 : time === null || time === void 0 ? void 0 : time.opened_at),
        trigger_price: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trigger_price,
        day_trade_is_day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.is_day_trade,
        day_trade_force_sell_event: day_trade === null || day_trade === void 0 ? void 0 : day_trade.force_sell_event,
        day_trade_message: (ref6 = day_trade === null || day_trade === void 0 ? void 0 : day_trade.message) !== null && ref6 !== void 0 ? ref6 : "",
        is_sharia: is_sharia,
        trailing_stop: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trailing_stop,
        platform_order_type: platform_order_type
    };
};
var orderList = function(orders) {
    var mappedData = orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
    return mappedData;
};
var formulaData = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, version = ref.version, formula = ref.formula, fee = ref.fee, preview_fee = ref.preview_fee, day_trade = ref.day_trade;
    var dayTradePreviewFee = (day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee) ? day_trade.preview_fee : preview_fee;
    return {
        version: version,
        fee: {
            buy: fee.buy,
            sell: fee.sell
        },
        formula: {
            buy_amount_broker_fee: formula.buy.broker_fee,
            buy_amount_exchange_fee: formula.buy.exchange_fee,
            buy_amount_fee: formula.buy.fee,
            buy_amount_invested: formula.buy.invested,
            buy_amount_invested_fee: formula.buy.invested_fee,
            ca_sell_amount_broker_fee: formula.ca_sell.broker_fee,
            ca_sell_amount_exchange_fee: formula.ca_sell.exchange_fee,
            ca_sell_amount_fee: formula.ca_sell.fee,
            ca_sell_amount_invested: formula.ca_sell.invested,
            ca_sell_amount_invested_fee: formula.ca_sell.invested_fee,
            sell_amount_broker_fee: formula.sell.broker_fee,
            sell_amount_exchange_fee: formula.sell.exchange_fee,
            sell_amount_fee: formula.sell.fee,
            sell_amount_invested: formula.sell.invested,
            sell_amount_invested_fee: formula.sell.invested_fee,
            sell_gain: formula.sell_gain,
            sell_profit_loss: formula.sell_profit_loss,
            amount_invested: formula.amount_invested,
            summary_equity: formula.summary.equity,
            summary_invested: formula.summary.invested,
            summary_net_profit_loss: formula.summary.net_profit_loss.value,
            summary_net_profit_loss_percentage: formula.summary.net_profit_loss.percentage,
            unrealised_gain: formula.unrealized.gain,
            unrealised_market_value: formula.unrealized.market_value,
            unrealised_profit_loss: formula.unrealized.profit_loss,
            day_trade_debt_ratio: formula.day_trade.debt.ratio,
            day_trade_debt_unrealized: formula.day_trade.debt.unrealized,
            day_trade_portion_order_amount: formula.day_trade.portion_order_amount,
            day_trade_investment_day_trade: formula.day_trade.investment.day_trade,
            day_trade_investment_portion_tb: formula.day_trade.investment.portion_tb,
            fee_buy: fee.buy,
            fee_sell: fee.sell,
            fee_buy_day_trade: day_trade.fee.buy,
            fee_sell_day_trade: day_trade.fee.sell
        },
        preview_fee: {
            broker_fee: preview_fee.broker_fee,
            exchange: {
                compositions: preview_fee.exchange.compositions,
                title: preview_fee.exchange.title,
                desc: preview_fee.exchange.desc,
                subtitle: preview_fee.exchange.subtitle,
                exchange_fee_total_buy: preview_fee.exchange.total_buy,
                exchange_fee_total_ca_buy: preview_fee.exchange.total_ca_buy,
                exchange_fee_total_ca_sell: preview_fee.exchange.total_ca_sell,
                exchange_fee_total_sell: preview_fee.exchange.total_sell,
                exchange_fee_total_title: preview_fee.exchange.total_title
            }
        },
        day_trade: {
            fee: {
                buy: day_trade.fee.buy,
                sell: day_trade.fee.sell
            },
            portion_deduct_to_tb: day_trade.portion_deduct_to_tb,
            preview_fee: {
                broker_fee: dayTradePreviewFee.broker_fee,
                exchange: {
                    compositions: dayTradePreviewFee.exchange.compositions,
                    title: dayTradePreviewFee.exchange.title,
                    desc: dayTradePreviewFee.exchange.desc,
                    subtitle: dayTradePreviewFee.exchange.subtitle,
                    exchange_fee_total_buy: dayTradePreviewFee.exchange.total_buy,
                    exchange_fee_total_ca_buy: dayTradePreviewFee.exchange.total_ca_buy,
                    exchange_fee_total_ca_sell: dayTradePreviewFee.exchange.total_ca_sell,
                    exchange_fee_total_sell: dayTradePreviewFee.exchange.total_sell,
                    exchange_fee_total_title: dayTradePreviewFee.exchange.total_title
                }
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList,
    formulaData: formulaData,
    portfolioItemFromBonds: portfolioItemFromBonds
});


/***/ })

}]);